export const EXERCISES = [
  {
    id: 'routine',
    title: 'La journée de Marie',
    level: 'A1',
    theme: 'Daily routine',
    warmup: [
      'Que faites-vous le matin ?',
      'À quelle heure vous levez-vous ?',
      'Prenez-vous un petit-déjeuner ?',
    ],
    text: `Bonjour, je m'appelle Marie. Je me réveille à 7 heures du matin. D'abord, je prends une douche, puis je prépare mon petit-déjeuner. Je mange du pain avec du beurre et je bois un café.

Je quitte la maison à 8 heures. Je prends le métro pour aller au travail. Je travaille dans un bureau au centre-ville. Ma journée de travail commence à 9 heures et se termine à 17 heures.

Après le travail, je fais les courses au supermarché. Le soir, je prépare le dîner et je regarde un film. Je me couche vers 23 heures.`,
    questions: [
      { q: 'À quelle heure Marie se réveille-t-elle ?', a: 'Marie se réveille à 7 heures du matin.' },
      { q: 'Que mange-t-elle au petit-déjeuner ?', a: 'Elle mange du pain avec du beurre et boit un café.' },
      { q: 'Comment va-t-elle au travail ?', a: 'Elle prend le métro.' },
      { q: 'Où travaille Marie ?', a: 'Elle travaille dans un bureau au centre-ville.' },
      { q: 'Que fait-elle après le travail ?', a: 'Elle fait les courses au supermarché.' },
    ],
    expression: [
      'Et vous, à quelle heure vous levez-vous ?',
      'Votre journée est-elle similaire à celle de Marie ?',
      'Décrivez votre routine du matin.',
    ],
    speaking: 'Décrivez votre journée à voix haute pendant 1 minute.',
  },
  {
    id: 'marche',
    title: 'Au marché',
    level: 'A1',
    theme: 'Shopping & food',
    warmup: [
      'Aimez-vous cuisiner ?',
      'Où achetez-vous vos fruits et légumes ?',
      'Quel est votre plat préféré ?',
    ],
    text: `Samedi matin, Sophie va au marché. Le marché est près de chez elle, dans la rue principale. Il y a beaucoup de stands colorés.

D'abord, elle achète des tomates, des carottes et de la salade chez le marchand de légumes. Ensuite, elle va chez le boulanger pour prendre une baguette et des croissants. Le boulanger est très gentil, il dit toujours « Bonjour Madame, comment allez-vous ? »

Sophie achète aussi du fromage — un camembert et du gruyère. Enfin, elle prend des pommes et des oranges.

Le marché est un endroit agréable. Sophie aime parler avec les vendeurs. Elle rentre chez elle à midi avec ses sacs pleins.`,
    questions: [
      { q: 'Quand Sophie va-t-elle au marché ?', a: 'Elle va au marché le samedi matin.' },
      { q: 'Où se trouve le marché ?', a: 'Le marché est dans la rue principale, près de chez elle.' },
      { q: 'Que dit le boulanger ?', a: 'Il dit « Bonjour Madame, comment allez-vous ? »' },
      { q: 'Quels fromages achète-t-elle ?', a: 'Elle achète un camembert et du gruyère.' },
      { q: 'À quelle heure rentre-t-elle ?', a: 'Elle rentre chez elle à midi.' },
    ],
    expression: [
      'Allez-vous souvent au marché ou au supermarché ?',
      'Quels fruits et légumes achetez-vous d\'habitude ?',
      'Décrivez votre dernière visite dans un magasin d\'alimentation.',
    ],
    speaking: 'Imaginez que vous êtes au marché. Dites ce que vous achetez et pourquoi.',
  },
  {
    id: 'presentation',
    title: 'Présentation personnelle',
    level: 'A1',
    theme: 'Introducing yourself',
    warmup: [
      'Comment vous appelez-vous ?',
      'D\'où venez-vous ?',
      'Qu\'est-ce que vous aimez faire ?',
    ],
    text: `— Bonjour, je m'appelle Lucas. Et toi ?
— Salut Lucas ! Moi, c'est Camille. Tu habites où ?
— J'habite à Bordeaux, dans le sud-ouest de la France. Et toi ?
— Moi, j'habite à Bruxelles, en Belgique. Qu'est-ce que tu fais dans la vie ?
— Je suis professeur de musique. J'enseigne la guitare et le piano. Et toi, tu travailles ?
— Oui, je suis infirmière. Je travaille à l'hôpital.
— C'est intéressant ! Tu as des loisirs ?
— Oui, j'aime beaucoup la lecture et la cuisine. Le week-end, je fais souvent des gâteaux. Et toi ?
— Moi, j'adore le sport. Je joue au football le samedi et je fais du vélo le dimanche.
— Super ! Enchanté, Lucas.
— Enchanté, Camille !`,
    questions: [
      { q: 'Où habite Lucas ?', a: 'Lucas habite à Bordeaux, dans le sud-ouest de la France.' },
      { q: 'Quel est le métier de Camille ?', a: 'Camille est infirmière. Elle travaille à l\'hôpital.' },
      { q: 'Quels instruments enseigne Lucas ?', a: 'Il enseigne la guitare et le piano.' },
      { q: 'Que fait Camille le week-end ?', a: 'Elle fait souvent des gâteaux.' },
      { q: 'Quel sport pratique Lucas le samedi ?', a: 'Il joue au football le samedi.' },
    ],
    expression: [
      'Présentez-vous : votre nom, votre ville, votre travail.',
      'Quels sont vos loisirs préférés ?',
      'Décrivez une personne que vous connaissez (nom, ville, métier, loisirs).',
    ],
    speaking: 'Présentez-vous en français pendant 1 minute : votre nom, votre ville, votre métier et vos loisirs.',
  },
  {
    id: 'journee-simple',
    title: 'Une journée simple',
    level: 'A1',
    theme: 'Daily life',
    warmup: [
      'Comment se passe une journée normale pour vous ?',
      'À quelle heure déjeunez-vous ?',
      'Que faites-vous le soir après le travail ?',
    ],
    text: `Je m'appelle Paul. J'ai 28 ans et je vis à Toulouse. Je travaille comme boulanger.

Mon réveil sonne à 4 heures du matin. C'est très tôt, mais j'aime mon métier. Je me lève, je prends un café rapide et je vais à la boulangerie à pied. La boulangerie est à dix minutes de chez moi.

Je commence à préparer le pain à 4 heures 30. Je fais des baguettes, des croissants et des pains au chocolat. Les premiers clients arrivent à 6 heures 30. Ils achètent du pain frais pour le petit-déjeuner.

À midi, je ferme la boulangerie et je rentre chez moi. Je prépare un déjeuner simple — souvent une salade ou des pâtes. L'après-midi, je me repose un peu, je lis le journal ou je regarde la télévision.

Le soir, je dîne à 19 heures et je me couche tôt, à 21 heures. Ma vie est simple, mais je suis content.`,
    questions: [
      { q: 'Quel est le métier de Paul ?', a: 'Paul est boulanger.' },
      { q: 'À quelle heure sonne son réveil ?', a: 'Son réveil sonne à 4 heures du matin.' },
      { q: 'Comment va-t-il à la boulangerie ?', a: 'Il va à la boulangerie à pied.' },
      { q: 'Que prépare-t-il le matin ?', a: 'Il fait des baguettes, des croissants et des pains au chocolat.' },
      { q: 'Que fait-il l\'après-midi ?', a: 'Il se repose, lit le journal ou regarde la télévision.' },
      { q: 'À quelle heure se couche-t-il ?', a: 'Il se couche à 21 heures.' },
    ],
    expression: [
      'Décrivez une journée typique dans votre vie.',
      'Votre journée ressemble-t-elle à celle de Paul ? Pourquoi ?',
      'Quel est votre moment préféré de la journée ?',
    ],
    speaking: 'Racontez votre journée d\'hier du matin au soir en français.',
  },
  {
    id: 'vacances',
    title: 'Mes vacances',
    level: 'A1',
    theme: 'Holidays & travel',
    warmup: [
      'Où aimez-vous aller en vacances ?',
      'Préférez-vous la plage ou la campagne ?',
      'Avec qui partez-vous en vacances ?',
    ],
    text: `L'été dernier, je suis allée en vacances avec ma famille. Nous sommes allés à Nice, dans le sud de la France. Nous avons pris le train depuis Paris. Le voyage a duré 5 heures.

À Nice, nous avons loué un petit appartement près de la mer. Chaque matin, nous allions à la plage. L'eau était bleue et chaude. Les enfants adoraient jouer dans le sable et nager.

L'après-midi, nous visitions la ville. Nous avons marché dans le Vieux Nice avec ses petites rues colorées. Nous avons mangé des glaces, de la socca et de la salade niçoise. C'était délicieux !

Un jour, nous avons visité le musée Matisse. Les tableaux étaient très beaux. Le soir, nous nous promenions sur la Promenade des Anglais et nous regardions le coucher de soleil.

Les vacances ont duré une semaine. C'était un moment merveilleux. J'espère y retourner l'année prochaine.`,
    questions: [
      { q: 'Où est allée la famille en vacances ?', a: 'La famille est allée à Nice, dans le sud de la France.' },
      { q: 'Comment ont-ils voyagé ?', a: 'Ils ont pris le train depuis Paris.' },
      { q: 'Où ont-ils logé ?', a: 'Ils ont loué un petit appartement près de la mer.' },
      { q: 'Qu\'est-ce qu\'ils ont mangé ?', a: 'Ils ont mangé des glaces, de la socca et de la salade niçoise.' },
      { q: 'Quel musée ont-ils visité ?', a: 'Ils ont visité le musée Matisse.' },
      { q: 'Combien de temps ont duré les vacances ?', a: 'Les vacances ont duré une semaine.' },
    ],
    expression: [
      'Racontez vos dernières vacances.',
      'Quelle est votre destination de vacances préférée et pourquoi ?',
      'Décrivez des vacances idéales pour vous.',
    ],
    speaking: 'Décrivez vos vacances préférées en français : où, avec qui, ce que vous avez fait.',
  },
  {
    id: 'travail',
    title: 'Mon travail',
    level: 'A1',
    theme: 'Work & office',
    warmup: [
      'Où travailles-tu ?',
      'Aimes-tu ton travail ?',
    ],
    text: `Je travaille dans un bureau. Mon travail commence le matin. Je parle avec mes collègues. J'utilise un ordinateur. À midi, je fais une pause. J'aime mon travail.`,
    questions: [
      { q: 'Où travaille la personne ?', a: 'Elle travaille dans un bureau.' },
      { q: 'Quand commence le travail ?', a: 'Le travail commence le matin.' },
      { q: 'Avec qui parle-t-elle ?', a: 'Elle parle avec ses collègues.' },
      { q: 'Que fait-elle à midi ?', a: 'Elle fait une pause.' },
      { q: 'Aime-t-elle son travail ?', a: 'Oui, elle aime son travail.' },
    ],
    expression: [
      'Où travailles-tu ou étudies-tu ?',
      'Que fais-tu pendant la journée ?',
      'Aimes-tu ton travail ou tes études ? Pourquoi ?',
    ],
    speaking: 'Parle de ton travail ou de tes études pendant 1 minute.',
  },
  {
    id: 'famille',
    title: 'Ma famille',
    level: 'A1',
    theme: 'Family',
    warmup: [
      'As-tu une grande famille ?',
      'Avec qui habites-tu ?',
    ],
    text: `J'ai une famille. J'ai un père et une mère. J'ai une sœur. Nous habitons ensemble. Le soir, nous parlons et nous dînons. J'aime ma famille.`,
    questions: [
      { q: 'Combien de personnes dans la famille ?', a: 'Il y a quatre personnes : le père, la mère, le narrateur et la sœur.' },
      { q: 'Qui sont les membres de la famille ?', a: 'Un père, une mère et une sœur.' },
      { q: 'Où habitent-ils ?', a: 'Ils habitent ensemble.' },
      { q: 'Que font-ils le soir ?', a: 'Le soir, ils parlent et ils dînent.' },
      { q: 'Aime-t-il sa famille ?', a: 'Oui, il aime sa famille.' },
    ],
    expression: [
      'Parle de ta famille.',
      'Avec qui habites-tu ?',
      'Que faites-vous ensemble ?',
    ],
    speaking: 'Présente ta famille à voix haute pendant 1 minute.',
  },
  {
    id: 'voyage',
    title: 'Le voyage de Thomas',
    level: 'A2',
    theme: 'Travel',
    warmup: [
      'Aimez-vous voyager ?',
      'Quelle est votre destination préférée ?',
      'Préférez-vous la mer ou la montagne ?',
    ],
    text: `Thomas a pris le train de Paris à Lyon la semaine dernière. Le voyage a duré deux heures. Il a réservé son billet sur Internet et il avait une place près de la fenêtre.

Dans le train, Thomas a lu un livre et écouté de la musique. Il a aussi parlé avec une dame assise à côté de lui. Elle s'appelait Claire et elle allait à Lyon pour rendre visite à sa fille.

À Lyon, Thomas est allé à l'hôtel pour déposer ses bagages. Ensuite, il a visité le Vieux Lyon et il a mangé dans un bouchon lyonnais. Il a goûté la quenelle, un plat typique de la région.

Le lendemain, il a pris le funiculaire pour monter à Fourvière et il a admiré la vue sur toute la ville. Thomas a beaucoup aimé Lyon. Il veut y retourner l'année prochaine.`,
    questions: [
      { q: 'Comment Thomas est-il allé à Lyon ?', a: 'Il a pris le train de Paris à Lyon.' },
      { q: 'Combien de temps a duré le voyage ?', a: 'Le voyage a duré deux heures.' },
      { q: 'Qui a-t-il rencontré dans le train ?', a: 'Il a parlé avec une dame appelée Claire.' },
      { q: 'Qu\'a-t-il mangé à Lyon ?', a: 'Il a mangé dans un bouchon lyonnais et a goûté la quenelle.' },
      { q: 'Qu\'a-t-il fait le lendemain ?', a: 'Il a pris le funiculaire pour monter à Fourvière et a admiré la vue.' },
    ],
    expression: [
      'Racontez votre dernier voyage.',
      'Quels endroits avez-vous visités récemment ?',
      'Si vous pouviez aller n\'importe où en France, où iriez-vous ?',
    ],
    speaking: 'Racontez un voyage que vous avez fait. Dites où, quand, comment, et ce que vous avez fait.',
  },
  {
    id: 'voisins',
    title: 'Les voisins',
    level: 'A2',
    theme: 'Relationships & neighbourhood',
    warmup: [
      'Connaissez-vous vos voisins ?',
      'Parlez-vous souvent avec eux ?',
      'Comment est votre quartier ?',
    ],
    text: `J'habite dans un petit immeuble au troisième étage. Mes voisins sont très sympathiques. Au deuxième étage, il y a Monsieur et Madame Dupont. Ils sont retraités et ils ont un petit chien qui s'appelle Coco.

Au premier étage, il y a une étudiante, Léa. Elle étudie la médecine à l'université. Elle est très occupée mais elle est toujours souriante. Parfois, nous prenons un café ensemble le dimanche.

Au rez-de-chaussée, il y a la boulangerie de Pierre. Pierre fait le meilleur pain du quartier. Chaque matin, l'odeur du pain frais monte dans les escaliers. C'est le meilleur réveil du monde.

J'aime beaucoup mon immeuble. C'est comme une petite famille.`,
    questions: [
      { q: 'À quel étage habite le narrateur ?', a: 'Il habite au troisième étage.' },
      { q: 'Qui sont Monsieur et Madame Dupont ?', a: 'Ce sont les voisins du deuxième étage, ils sont retraités.' },
      { q: 'Comment s\'appelle le chien ?', a: 'Le chien s\'appelle Coco.' },
      { q: 'Que fait Léa ?', a: 'Elle étudie la médecine à l\'université.' },
      { q: 'Qu\'y a-t-il au rez-de-chaussée ?', a: 'Il y a la boulangerie de Pierre.' },
    ],
    expression: [
      'Décrivez l\'endroit où vous habitez.',
      'Avez-vous de bons rapports avec vos voisins ?',
      'Que représente pour vous un bon quartier ?',
    ],
    speaking: 'Décrivez votre immeuble ou votre maison et les gens qui habitent autour de vous.',
  },
  {
    id: 'vie-etudiante',
    title: 'La vie quotidienne d\'un étudiant',
    level: 'A2',
    theme: 'Student life',
    warmup: [
      'À quelle heure te lèves-tu ?',
      'Que fais-tu pendant la journée ?',
    ],
    text: `Je m'appelle Sarah et je suis étudiante en France. J'habite dans un petit appartement près de mon université. La semaine, je me réveille à 7 heures du matin. Je prends une douche, je m'habille et je prends mon petit déjeuner à la maison.

À 8h30, je pars à l'université en bus. Les cours commencent à 9 heures. J'ai des cours de français, d'histoire et d'informatique. À midi, je mange à la cantine avec mes amis. Nous parlons de nos cours et de nos projets.

L'après-midi, j'étudie à la bibliothèque ou je fais mes devoirs. Le soir, je rentre chez moi vers 18 heures. Je prépare le dîner et je mange tranquillement. Après le dîner, je regarde une série ou je lis un livre. Je me couche à 23 heures.

J'aime ma vie d'étudiante car elle est simple et organisée.`,
    questions: [
      { q: 'Qui est Sarah ?', a: 'Sarah est une étudiante en France.' },
      { q: 'Où habite-t-elle ?', a: 'Elle habite dans un petit appartement près de son université.' },
      { q: 'À quelle heure part-elle à l\'université ?', a: 'Elle part à l\'université à 8h30.' },
      { q: 'Où mange-t-elle le midi ?', a: 'Elle mange à la cantine avec ses amis.' },
      { q: 'Que fait-elle l\'après-midi ?', a: 'Elle étudie à la bibliothèque ou fait ses devoirs.' },
      { q: 'Vrai ou faux : Elle va à l\'université en métro.', a: 'Faux — elle va à l\'université en bus.' },
      { q: 'Vrai ou faux : Elle se couche à 23 heures.', a: 'Vrai.' },
    ],
    expression: [
      'Décris ta journée normale.',
      'Que fais-tu après les cours ou le travail ?',
      'Aimes-tu ta routine ? Pourquoi ?',
    ],
    speaking: 'Décris ta journée à voix haute pendant 1 à 2 minutes.',
  },
  {
    id: 'premier-travail',
    title: 'Mon premier travail',
    level: 'A2',
    theme: 'Work experience',
    warmup: [
      'As-tu déjà travaillé ?',
      'Quel est ton travail idéal ?',
    ],
    text: `Je m'appelle Nadia et j'ai 24 ans. Je travaille dans un café à Lyon. C'est mon premier travail. Je commence le travail à 8 heures du matin. Je prépare le café, je parle avec les clients et je nettoie les tables.

Les clients sont souvent gentils. Ils commandent du café, du thé et des croissants. À midi, j'ai une pause de trente minutes. Je mange un sandwich et je bois de l'eau.

Le travail n'est pas toujours facile, mais j'aime mon équipe. Mes collègues m'aident beaucoup. Le soir, je suis fatiguée mais contente. Grâce à ce travail, je gagne de l'argent et je pratique le français.`,
    questions: [
      { q: 'Où travaille Nadia ?', a: 'Nadia travaille dans un café à Lyon.' },
      { q: 'À quelle heure commence-t-elle le travail ?', a: 'Elle commence à 8 heures du matin.' },
      { q: 'Que commandent les clients ?', a: 'Ils commandent du café, du thé et des croissants.' },
      { q: 'Combien de temps dure sa pause ?', a: 'Sa pause dure trente minutes.' },
      { q: 'Pourquoi aime-t-elle son travail ?', a: 'Elle aime son équipe, elle gagne de l\'argent et elle pratique le français.' },
    ],
    expression: [
      'As-tu déjà travaillé ?',
      'Parle de ton travail ou de ton travail idéal.',
      'Aimes-tu travailler avec des collègues ? Pourquoi ?',
    ],
    speaking: 'Parle de ton expérience de travail pendant 1 à 2 minutes.',
  },
  {
    id: 'vacances-campagne',
    title: 'Mes vacances à la campagne',
    level: 'A2',
    theme: 'Countryside holidays',
    warmup: [
      'Où préfères-tu passer tes vacances ?',
      'Aimes-tu la nature ?',
    ],
    text: `Pendant l'été, je passe mes vacances à la campagne chez mes grands-parents. Ils habitent dans une petite maison avec un jardin. Le matin, je me lève tôt et je prends le petit déjeuner avec eux.

Après, je vais me promener dans la nature. L'après-midi, j'aide mon grand-père dans le jardin. Nous plantons des légumes et nous arrosons les fleurs. Ma grand-mère prépare de bons plats français.

Le soir, nous regardons la télévision ou nous parlons ensemble. J'aime la campagne parce que c'est calme et reposant. Il n'y a pas beaucoup de bruit. Ces vacances sont simples mais très agréables.`,
    questions: [
      { q: 'Où passe-t-il ses vacances ?', a: 'Il passe ses vacances à la campagne chez ses grands-parents.' },
      { q: 'Avec qui prend-il le petit déjeuner ?', a: 'Il prend le petit déjeuner avec ses grands-parents.' },
      { q: 'Que fait-il dans le jardin ?', a: 'Il plante des légumes et arrose les fleurs avec son grand-père.' },
      { q: 'Pourquoi aime-t-il la campagne ?', a: 'Il aime la campagne parce que c\'est calme et reposant.' },
    ],
    expression: [
      'Préfères-tu la campagne ou la ville ? Pourquoi ?',
      'Que fais-tu pendant tes vacances ?',
    ],
    speaking: 'Parle de tes vacances préférées pendant 1 à 2 minutes.',
  },
  {
    id: 'demander-chemin',
    title: 'Demander son chemin',
    level: 'A2',
    theme: 'Directions & navigation',
    warmup: [
      'As-tu déjà été perdu dans une ville ?',
      'Comment fais-tu pour trouver ton chemin ?',
    ],
    text: `Hier, je suis allé dans une nouvelle ville pour la première fois. Je voulais visiter un musée, mais je ne savais pas où il se trouvait. J'ai demandé mon chemin à une dame dans la rue.

Elle m'a expliqué que je devais aller tout droit, puis tourner à gauche après la banque. Ensuite, il fallait continuer jusqu'au feu rouge et traverser la rue. Le musée était juste en face d'un parc.

Grâce à ses explications, j'ai trouvé facilement. J'étais très content et je l'ai remerciée.`,
    questions: [
      { q: 'Pourquoi le narrateur demande-t-il son chemin ?', a: 'Parce qu\'il voulait visiter un musée mais ne savait pas où il se trouvait.' },
      { q: 'À qui parle-t-il ?', a: 'Il parle à une dame dans la rue.' },
      { q: 'Que doit-il faire après la banque ?', a: 'Il doit tourner à gauche.' },
      { q: 'Où se trouve le musée ?', a: 'Le musée est juste en face d\'un parc, après le feu rouge.' },
      { q: 'Trouvez dans le texte : a) aller en ligne droite b) passer d\'un côté à l\'autre de la rue', a: 'a) aller tout droit b) traverser la rue' },
    ],
    expression: [
      'Demande ton chemin pour aller à un endroit.',
      'Explique comment aller de chez toi à ton école.',
    ],
    speaking: 'Explique un itinéraire simple pour aller à un endroit que tu connais bien.',
  },
  {
    id: 'voyager-seul',
    title: 'Voyager seul',
    level: 'A2',
    theme: 'Travel & independence',
    warmup: [
      'Aimerais-tu voyager seul ?',
      'Qu\'est-ce qui te fait peur quand tu voyages ?',
    ],
    text: `L'année dernière, j'ai voyagé seul pour la première fois. Je suis allé à Delhi pour un court séjour. Au début, j'étais un peu stressé, car je devais tout organiser moi-même.

J'ai réservé un hôtel en ligne et j'ai pris un taxi depuis l'aéroport. Pendant le séjour, j'ai visité des monuments et j'ai mangé dans des restaurants locaux. J'ai aussi rencontré de nouvelles personnes.

Voyager seul m'a aidé à devenir plus indépendant. C'était une expérience très enrichissante.`,
    questions: [
      { q: 'Où est allé le narrateur ?', a: 'Il est allé à Delhi.' },
      { q: 'Pourquoi était-il stressé au début ?', a: 'Parce qu\'il devait tout organiser lui-même.' },
      { q: 'Comment a-t-il organisé son voyage ?', a: 'Il a réservé un hôtel en ligne et pris un taxi depuis l\'aéroport.' },
      { q: 'Qu\'a-t-il appris grâce à cette expérience ?', a: 'Voyager seul l\'a aidé à devenir plus indépendant.' },
      { q: 'Trouvez un mot qui signifie : a) réservé à l\'avance b) sans aide', a: 'a) réservé en ligne b) moi-même / seul' },
    ],
    expression: [
      'Aimerais-tu voyager seul ? Pourquoi ?',
      'Parle d\'un voyage que tu as fait.',
    ],
    speaking: 'Raconte un voyage que tu as fait ou que tu aimerais faire.',
  },
  {
    id: 'demander-remboursement',
    title: 'Demander un remboursement',
    level: 'A2',
    theme: 'Shopping & consumer rights',
    warmup: [
      'As-tu déjà eu un problème avec un produit ?',
      'Que fais-tu quand un achat ne fonctionne pas ?',
    ],
    text: `La semaine dernière, j'ai acheté un casque audio dans un magasin. Quand je suis rentré chez moi, j'ai remarqué qu'il ne fonctionnait pas correctement.

Le lendemain, je suis retourné au magasin avec le ticket de caisse. J'ai expliqué le problème au vendeur. Il a vérifié le produit et a confirmé qu'il était défectueux.

Il m'a proposé un échange ou un remboursement. J'ai choisi le remboursement. Le vendeur a été très professionnel.`,
    questions: [
      { q: 'Qu\'a acheté le narrateur ?', a: 'Il a acheté un casque audio.' },
      { q: 'Quel problème a-t-il eu ?', a: 'Le casque ne fonctionnait pas correctement.' },
      { q: 'Que fait-il le lendemain ?', a: 'Il retourne au magasin avec le ticket de caisse et explique le problème.' },
      { q: 'Quelle solution choisit-il ?', a: 'Il choisit le remboursement.' },
      { q: 'Trouvez dans le texte : a) preuve d\'achat b) objet qui ne marche pas', a: 'a) ticket de caisse b) défectueux' },
    ],
    expression: [
      'As-tu déjà eu un problème avec un produit ?',
      'Que fais-tu dans ce cas ?',
    ],
    speaking: 'Raconte une situation où tu as dû retourner un produit ou demander de l\'aide dans un magasin.',
  },
  {
    id: 'faire-du-sport',
    title: 'Faire du sport',
    level: 'A2',
    theme: 'Sports & health',
    warmup: [
      'Quel sport pratiques-tu ?',
      'Pourquoi le sport est-il important selon toi ?',
    ],
    text: `Je fais du sport trois fois par semaine. Le lundi, je vais à la salle de sport avec mon ami. Nous faisons des exercices pendant une heure.

Le mercredi, je joue au football dans un parc. Le dimanche, je fais du jogging le matin.

Le sport m'aide à rester en forme et à me sentir bien. Parfois, c'est difficile, mais je suis motivé. J'aime aussi essayer de nouveaux sports.`,
    questions: [
      { q: 'Combien de fois fait-il du sport ?', a: 'Il fait du sport trois fois par semaine.' },
      { q: 'Que fait-il le lundi ?', a: 'Il va à la salle de sport avec son ami.' },
      { q: 'Où joue-t-il au football ?', a: 'Il joue au football dans un parc.' },
      { q: 'Pourquoi aime-t-il le sport ?', a: 'Le sport l\'aide à rester en forme et à se sentir bien.' },
      { q: 'Trouvez : a) courir lentement b) endroit pour s\'entraîner', a: 'a) jogging b) salle de sport' },
    ],
    expression: [
      'Quel sport pratiques-tu ?',
      'Pourquoi le sport est-il important ?',
    ],
    speaking: 'Parle de ton sport préféré et de ta routine sportive.',
  },
  {
    id: 'celebrer-fete',
    title: 'Célébrer une fête',
    level: 'A2',
    theme: 'Celebrations & traditions',
    warmup: [
      'Quelle fête aimes-tu célébrer ?',
      'Comment la célèbres-tu ?',
    ],
    text: `Chaque année, je célèbre une grande fête avec ma famille. Nous décorons la maison avec des lumières et des fleurs. Ma mère prépare des plats traditionnels.

Le soir, nous invitons des amis et nous partageons le repas. Nous écoutons de la musique et nous dansons.

Cette fête est très importante pour nous. Elle nous permet de passer du temps ensemble. J'aime beaucoup cette ambiance festive.`,
    questions: [
      { q: 'Que fait la famille pour la fête ?', a: 'Ils décorent la maison avec des lumières et des fleurs, et la mère prépare des plats traditionnels.' },
      { q: 'Qui vient le soir ?', a: 'Des amis viennent le soir.' },
      { q: 'Que font-ils ensemble ?', a: 'Ils partagent le repas, écoutent de la musique et dansent.' },
      { q: 'Pourquoi cette fête est-elle importante ?', a: 'Elle permet à la famille de passer du temps ensemble.' },
      { q: 'Trouvez : a) décorer b) repas spécial', a: 'a) décorons b) plats traditionnels' },
    ],
    expression: [
      'Quelle fête aimes-tu célébrer ?',
      'Comment la célèbres-tu ?',
    ],
    speaking: 'Décris ta fête préférée : ce que tu fais, ce que tu manges et avec qui tu la célèbres.',
  },
  {
    id: 'faire-menage',
    title: 'Faire le ménage',
    level: 'A2',
    theme: 'Daily chores & home',
    warmup: [
      'Aides-tu à faire le ménage chez toi ?',
      'Quelle tâche préfères-tu ou détestes-tu ?',
    ],
    text: `Le week-end, je fais le ménage chez moi. Je commence par ranger ma chambre. Ensuite, je passe l'aspirateur et je nettoie les meubles.

Je lave aussi la salle de bain. Parfois, j'écoute de la musique pendant que je travaille.

Après le ménage, la maison est propre et agréable. Je suis fatigué, mais satisfait. J'aime vivre dans un espace propre.`,
    questions: [
      { q: 'Quand fait-il le ménage ?', a: 'Il fait le ménage le week-end.' },
      { q: 'Que fait-il en premier ?', a: 'Il commence par ranger sa chambre.' },
      { q: 'Que nettoie-t-il ?', a: 'Il passe l\'aspirateur, nettoie les meubles et lave la salle de bain.' },
      { q: 'Comment se sent-il après ?', a: 'Il est fatigué mais satisfait.' },
      { q: 'Trouvez : a) nettoyer le sol b) mettre les choses en ordre', a: 'a) passer l\'aspirateur b) ranger' },
    ],
    expression: [
      'Aides-tu à faire le ménage chez toi ?',
      'Quelle tâche préfères-tu ou détestes-tu ?',
    ],
    speaking: 'Parle de ta routine de ménage : ce que tu fais et comment tu te sens après.',
  },
  {
    id: 'objet-perdu-cles',
    title: 'Il retrouve ses clés après une journée compliquée',
    level: 'A2',
    theme: 'Daily life — Presse française (article simulé)',
    warmup: [
      'Avez-vous déjà perdu un objet important ?',
      'Que faites-vous quand vous perdez quelque chose ?',
    ],
    text: `Hier matin, Julien est sorti de chez lui pour aller travailler. Comme d'habitude, il a pris son sac et a fermé la porte rapidement. Mais en arrivant au bureau, il s'est rendu compte qu'il n'avait plus ses clés.

Au début, il a pensé qu'il les avait oubliées à la maison. Mais il était sûr de les avoir dans sa poche en partant. Il a alors commencé à réfléchir à tous les endroits où il était passé.

Pendant la pause de midi, Julien est retourné dans les rues près de son appartement. Il a regardé par terre et est entré dans un café où il s'était arrêté le matin. Le serveur lui a dit qu'il n'avait rien trouvé.

Un peu inquiet, Julien a décidé d'appeler son colocataire pour vérifier si les clés étaient à la maison. Mais elles n'y étaient pas. Il commençait à penser qu'il les avait vraiment perdues.

Finalement, en fin de journée, il a reçu un message d'un voisin. Ce voisin avait trouvé les clés devant l'immeuble et avait vu le nom de Julien sur un porte-clés. Soulagé, Julien est allé les récupérer le soir même.

Cette expérience lui a montré qu'il devait faire plus attention à ses affaires.`,
    questions: [
      { q: 'Quand Julien a-t-il remarqué qu\'il avait perdu ses clés ?', a: 'Il a remarqué qu\'il n\'avait plus ses clés en arrivant au bureau.' },
      { q: 'Pourquoi pense-t-il au début qu\'elles sont à la maison ?', a: 'Parce qu\'il a pensé qu\'il les avait oubliées à la maison.' },
      { q: 'Quelles actions fait-il pour les retrouver ?', a: 'Il retourne dans les rues près de son appartement, regarde par terre, entre dans un café et appelle son colocataire.' },
      { q: 'Pourquoi appelle-t-il son colocataire ?', a: 'Pour vérifier si les clés étaient à la maison.' },
      { q: 'Comment retrouve-t-il finalement ses clés ?', a: 'Un voisin a trouvé les clés devant l\'immeuble et a envoyé un message à Julien grâce au nom sur le porte-clés.' },
    ],
    expression: [
      'Racontez la journée de Julien avec vos propres mots.',
      'Imaginez ce que Julien va faire à l\'avenir pour ne plus perdre ses clés.',
    ],
    speaking: 'Avez-vous déjà perdu un objet important ? Racontez votre expérience.',
  },
  {
    id: 'vacances-france',
    title: 'Mes premières vacances en France',
    level: 'B1',
    theme: 'Travel narrative',
    warmup: [
      'Es-tu déjà allé(e) à l\'étranger ?',
      'Aimes-tu voyager ? Pourquoi ?',
    ],
    text: `L'été dernier, j'ai passé deux semaines en France avec mon meilleur ami. C'était notre premier voyage ensemble et nous étions très enthousiastes.

Nous sommes d'abord allés à Paris. Nous avons visité la Tour Eiffel, le musée du Louvre et les Champs-Élysées. J'ai été impressionné par la beauté de la ville et par l'architecture des bâtiments. Nous avons aussi goûté des crêpes près de Montmartre — elles étaient délicieuses !

Après trois jours à Paris, nous avons pris le train pour Nice. Le trajet a duré environ six heures, mais le paysage était magnifique. À Nice, nous avons loué un petit studio près de la Promenade des Anglais. Chaque matin, nous allions à la plage. L'eau de la Méditerranée était claire et tiède. L'après-midi, nous nous promenions dans le Vieux Nice, nous dégustions de la socca et de la salade niçoise.

Le dernier week-end, nous avons décidé de visiter les montagnes. Nous avons fait une randonnée dans le parc national du Mercantour. C'était fatigant mais la vue depuis le sommet valait vraiment l'effort. Nous avons vu des marmottes et des aigles.

Ce voyage m'a donné envie d'apprendre le français plus sérieusement. J'espère y retourner l'année prochaine, peut-être pour explorer la Bretagne ou la Provence.`,
    questions: [
      { q: 'Où est allé le narrateur ?', a: 'Il est allé en France — à Paris, Nice, et dans le parc du Mercantour.' },
      { q: 'Avec qui a-t-il voyagé ?', a: 'Il a voyagé avec son meilleur ami.' },
      { q: 'Combien de temps ont duré les vacances ?', a: 'Les vacances ont duré deux semaines.' },
      { q: 'Qu\'ont-ils visité à Paris ?', a: 'Ils ont visité la Tour Eiffel, le musée du Louvre et les Champs-Élysées.' },
      { q: 'Que faisaient-ils à Nice chaque matin ?', a: 'Chaque matin, ils allaient à la plage.' },
      { q: 'Quelle activité ont-ils faite dans les montagnes ?', a: 'Ils ont fait une randonnée dans le parc national du Mercantour.' },
    ],
    expression: [
      'As-tu déjà voyagé ? Où ?',
      'Préfères-tu la plage ou la montagne ? Pourquoi ?',
      'Que fais-tu pendant tes vacances ?',
    ],
    speaking: 'Raconte tes dernières vacances pendant 2 minutes.',
  },
  {
    id: 'vacances-famille',
    title: 'Des vacances en famille inoubliables',
    level: 'B1',
    theme: 'Family holidays',
    warmup: [
      'Aimes-tu partir en vacances en famille ?',
      'Qu\'est-ce que tu fais généralement en vacances ?',
    ],
    text: `L'été dernier, j'ai passé deux semaines de vacances avec ma famille dans le sud de la France. Nous avons loué une maison près de la mer, dans un petit village calme. Chaque matin, nous prenions le petit déjeuner ensemble sur la terrasse. Nous parlions de nos projets pour la journée et nous décidions quoi faire.

La plupart du temps, nous allions à la plage. Mon père aimait lire sous le parasol, tandis que ma mère marchait au bord de l'eau. Moi, je nageais souvent avec mes cousins. Parfois, nous visitions des villes voisines et découvrions des marchés locaux. J'aimais beaucoup observer les gens et goûter des spécialités régionales.

Le soir, nous préparions le dîner ensemble. Chacun aidait en cuisine, et nous mangions tard en discutant. Ces moments étaient très importants pour moi, car nous n'avons pas souvent l'occasion de passer autant de temps ensemble pendant l'année.

Ces vacances m'ont permis de me reposer, mais aussi de renforcer les liens familiaux. Elles resteront un très beau souvenir.`,
    questions: [
      { q: 'Où la famille a-t-elle passé ses vacances ?', a: 'Dans le sud de la France, dans un petit village calme près de la mer.' },
      { q: 'Combien de temps ont duré les vacances ?', a: 'Les vacances ont duré deux semaines.' },
      { q: 'Que faisaient-ils le matin ensemble ?', a: 'Ils prenaient le petit déjeuner ensemble sur la terrasse et planifiaient la journée.' },
      { q: 'Donne deux activités à la plage.', a: 'Le père lisait sous le parasol, la mère marchait au bord de l\'eau, le narrateur nageait avec ses cousins.' },
      { q: 'Qu\'est-ce que le narrateur aimait découvrir ?', a: 'Il aimait observer les gens et goûter des spécialités régionales dans les marchés locaux.' },
      { q: 'Vrai ou faux : La famille mangeait toujours au restaurant.', a: 'Faux — ils préparaient le dîner ensemble à la maison.' },
      { q: 'Vrai ou faux : Le narrateur ne passait pas de temps avec ses cousins.', a: 'Faux — il nageait souvent avec ses cousins.' },
    ],
    expression: [
      'Préfères-tu les vacances en famille ou entre amis ? Pourquoi ?',
      'Pourquoi les vacances sont-elles importantes selon toi ?',
    ],
    speaking: 'Raconte un souvenir de vacances important pendant 2 à 3 minutes.',
  },
  {
    id: 'habitudes',
    title: 'Changer ses habitudes quotidiennes',
    level: 'B1',
    theme: 'Personal development',
    warmup: [
      'As-tu déjà changé une habitude importante ?',
      'Est-il difficile de changer sa routine ?',
    ],
    text: `Depuis le début de cette année, j'ai décidé de changer mes habitudes quotidiennes. Avant, je me levais tard et je commençais souvent la journée en retard. Je mangeais rapidement et je partais sans vraiment réfléchir à mon organisation. Un jour, je me suis rendu compte que cette routine me rendait stressé et fatigué.

J'ai donc décidé de me lever plus tôt. Le matin, je prends maintenant le temps de préparer mon petit déjeuner et de planifier ma journée. Je note mes tâches importantes et je fais une courte pause avant de partir.

Grâce à ce changement, je suis plus concentré au travail et je gère mieux mon temps. L'après-midi, je fais mes tâches les plus difficiles quand je suis encore motivé. Le soir, je limite l'utilisation de mon téléphone et je lis un livre pour me détendre.

Changer mes habitudes n'a pas été facile au début, mais aujourd'hui je vois des résultats positifs. Je me sens plus calme et plus organisé.`,
    questions: [
      { q: 'Pourquoi le narrateur a-t-il changé sa routine ?', a: 'Parce que sa routine le rendait stressé et fatigué.' },
      { q: 'Comment était sa routine avant ?', a: 'Il se levait tard, mangeait rapidement et partait sans organisation.' },
      { q: 'Que fait-il maintenant le matin ?', a: 'Il prépare son petit déjeuner, planifie sa journée et note ses tâches importantes.' },
      { q: 'Quels sont les résultats du changement ?', a: 'Il est plus concentré, plus calme et plus organisé.' },
      { q: 'Vrai ou faux : Il change sa routine à cause du travail uniquement.', a: 'Faux — il change car sa routine le rendait stressé et fatigué en général.' },
      { q: 'Vrai ou faux : Il utilise plus son téléphone maintenant.', a: 'Faux — il limite l\'utilisation de son téléphone le soir.' },
    ],
    expression: [
      'As-tu déjà changé une habitude ?',
      'Quelle habitude aimerais-tu améliorer ? Pourquoi ?',
    ],
    speaking: 'Explique une habitude que tu veux changer pendant 2 à 3 minutes.',
  },
  {
    id: 'teletravail-durable',
    title: 'Le télétravail, une solution durable ?',
    level: 'B2',
    theme: 'Work & society',
    warmup: [
      'Le télétravail est-il une solution d\'avenir ou une tendance temporaire ?',
    ],
    text: `Depuis quelques années, le télétravail s'est progressivement installé dans les habitudes professionnelles, au point de redéfinir certaines attentes des salariés.

Ce mode d'organisation, initialement adopté par contrainte, semble désormais répondre à une demande croissante d'autonomie. Pourtant, cette évolution ne fait pas l'unanimité.

Si certains y voient une opportunité d'améliorer leur qualité de vie, d'autres évoquent une frontière de plus en plus floue entre vie professionnelle et vie personnelle. En effet, travailler depuis chez soi suppose une discipline que tous ne maîtrisent pas nécessairement.

Du côté des entreprises, la question reste tout aussi complexe. Réduction des coûts ou perte de cohésion ? Gain de productivité ou difficulté de supervision ? Les avis divergent.

Ainsi, loin de constituer une solution évidente, le télétravail semble plutôt s'inscrire dans une transformation plus large du rapport au travail, dont les effets restent encore à mesurer.`,
    questions: [
      { q: 'En quoi le télétravail modifie-t-il les attentes des salariés ?', a: 'Il répond à une demande croissante d\'autonomie et redéfinit les attentes en matière de qualité de vie et d\'organisation du travail.' },
      { q: 'Pourquoi peut-on dire que le télétravail ne fait pas l\'unanimité ?', a: 'Certains y voient une amélioration de la qualité de vie, tandis que d\'autres soulignent le flou entre vie professionnelle et personnelle et le manque de discipline.' },
      { q: 'Expliquez l\'expression : « une frontière de plus en plus floue ».', a: 'Cela signifie que la séparation entre le travail et la vie personnelle devient moins nette, les deux sphères se mélangent quand on travaille depuis chez soi.' },
      { q: 'Reformulez : « les effets restent encore à mesurer ».', a: 'On ne connaît pas encore toutes les conséquences de cette transformation ; il faudra du temps pour en évaluer pleinement l\'impact.' },
      { q: 'L\'auteur adopte-t-il une position neutre, positive ou critique ? Justifiez.', a: 'L\'auteur adopte une position nuancée et plutôt neutre. Il présente les arguments des deux camps sans prendre parti, tout en soulignant la complexité du sujet.' },
    ],
    expression: [
      'Selon vous, le télétravail améliore-t-il réellement la qualité de vie ?',
    ],
    speaking: 'Présentez une analyse nuancée du télétravail pendant 3 à 4 minutes.',
  },
  {
    id: 'apprendre-francais',
    title: 'Apprendre le français : un vrai défi',
    level: 'B1',
    theme: 'Language learning',
    warmup: [
      'Est-ce que le français est difficile pour toi ?',
      'Quelles stratégies utilises-tu pour apprendre une langue ?',
    ],
    text: `Quand j'ai commencé à apprendre le français, je trouvais cette langue très difficile. La prononciation était différente de ma langue maternelle et je comprenais mal les conversations. En classe, j'avais peur de faire des erreurs, alors je parlais peu.

Avec le temps, j'ai changé ma méthode de travail. J'ai commencé à écouter des chansons françaises et à regarder des vidéos simples. Je faisais aussi mes devoirs régulièrement et je notais les nouveaux mots dans un cahier. Petit à petit, j'ai pris confiance.

Un jour, j'ai parlé français avec un touriste dans ma ville. La conversation était courte, mais j'étais très fier de moi. J'ai compris que faire des erreurs faisait partie de l'apprentissage.

Aujourd'hui, je continue à apprendre le français parce que cette langue est utile pour voyager et travailler. Même si ce n'est pas toujours facile, je suis motivé à progresser.`,
    questions: [
      { q: 'Pourquoi le français était-il difficile au début ?', a: 'La prononciation était différente de sa langue maternelle et il comprenait mal les conversations.' },
      { q: 'Quelles méthodes a-t-il utilisées pour progresser ?', a: 'Il a écouté des chansons françaises, regardé des vidéos simples, fait ses devoirs régulièrement et noté les nouveaux mots dans un cahier.' },
      { q: 'Quelle expérience lui a donné confiance ?', a: 'Il a parlé français avec un touriste dans sa ville.' },
    ],
    expression: [
      'Qu\'est-ce qui est difficile pour toi en français ?',
      'Que fais-tu pour progresser ?',
    ],
    speaking: 'Explique ton parcours d\'apprentissage du français pendant 2 à 3 minutes.',
  },
  {
    id: 'manifestation-cantine',
    title: 'Les étudiants manifestent pour une meilleure cantine',
    level: 'B1',
    theme: 'Student life & protest',
    warmup: [
      'Penses-tu que les étudiants doivent protester pour leurs droits ?',
      'Quels problèmes peuvent exister à l\'école ?',
    ],
    text: `Hier matin, les étudiants du lycée technique Victor-Hugo ont organisé une manifestation pacifique devant leur établissement. Depuis plusieurs mois, ils se plaignent de la mauvaise qualité des repas servis à la cantine scolaire. Selon eux, les portions sont insuffisantes et les menus manquent de diversité.

La manifestation a débuté à huit heures, juste avant les cours. Les élèves avaient préparé des pancartes et des slogans pour exprimer leur mécontentement.

La direction du lycée a rapidement réagi en invitant une délégation d'élèves à discuter. Le proviseur a reconnu certains problèmes et a promis d'ouvrir un dialogue. Les parents d'élèves soutiennent largement cette initiative.

Une réunion est prévue pour trouver des solutions concrètes.`,
    questions: [
      { q: 'Pourquoi les étudiants ont-ils manifesté ?', a: 'Ils se plaignent de la mauvaise qualité des repas servis à la cantine scolaire.' },
      { q: 'Quels problèmes sont mentionnés ?', a: 'Les portions sont insuffisantes et les menus manquent de diversité.' },
      { q: 'Comment la direction a-t-elle réagi ?', a: 'Le proviseur a invité une délégation d\'élèves à discuter et a promis d\'ouvrir un dialogue.' },
      { q: 'Vrai ou faux : La manifestation était violente.', a: 'Faux — la manifestation était pacifique.' },
      { q: 'Vrai ou faux : Les parents soutiennent les élèves.', a: 'Vrai — les parents d\'élèves soutiennent largement cette initiative.' },
    ],
    expression: [
      'Penses-tu que cette manifestation est justifiée ? Pourquoi ?',
      'As-tu déjà vu une situation similaire ?',
    ],
    speaking: 'Donne ton opinion sur les manifestations étudiantes pendant 2 à 3 minutes.',
  },
  {
    id: 'ia-apprentissage',
    title: 'L\'intelligence artificielle et l\'apprentissage',
    level: 'B2',
    theme: 'Education & technology',
    warmup: [
      'L\'apprentissage peut-il être totalement automatisé ?',
    ],
    text: `L'intégration de l'intelligence artificielle dans le domaine éducatif suscite autant d'enthousiasme que d'interrogations.

D'un côté, ces technologies promettent un apprentissage plus flexible, capable de s'adapter au rythme et aux besoins de chaque individu. D'un autre, elles posent la question du rôle de l'enseignant dans un environnement de plus en plus automatisé.

Certains défendent l'idée d'une démocratisation de l'éducation, rendue possible grâce à l'accès facilité aux ressources. Cependant, cette vision optimiste tend parfois à négliger une dimension essentielle : celle de l'interaction humaine.

Apprendre ne consiste pas uniquement à assimiler des informations, mais aussi à développer une capacité à interpréter, à douter, et à interagir.

Dans ce contexte, l'intelligence artificielle apparaît moins comme un substitut que comme un outil, dont l'efficacité dépendra largement de la manière dont il est utilisé.`,
    questions: [
      { q: 'Quelle tension principale est présentée dans le texte ?', a: 'La tension entre l\'enthousiasme pour un apprentissage flexible et automatisé, et les interrogations sur la perte de l\'interaction humaine et du rôle de l\'enseignant.' },
      { q: 'Pourquoi l\'auteur critique-t-il une vision optimiste de l\'IA ?', a: 'Parce que cette vision tend à négliger la dimension essentielle de l\'interaction humaine dans l\'apprentissage.' },
      { q: 'Expliquez : « apprendre ne consiste pas uniquement à assimiler des informations ».', a: 'L\'apprentissage va au-delà de la mémorisation ; il implique aussi la capacité à interpréter, à exercer un esprit critique (douter) et à échanger avec les autres.' },
      { q: 'Reformulez : « l\'efficacité dépendra largement de la manière dont il est utilisé ».', a: 'Le succès de l\'IA dans l\'éducation ne dépend pas de la technologie elle-même, mais de la façon dont les enseignants et les apprenants choisissent de l\'utiliser.' },
      { q: 'Quelle est la position implicite de l\'auteur ? Justifiez.', a: 'L\'auteur adopte une position prudente et nuancée. Il reconnaît le potentiel de l\'IA tout en insistant sur ses limites, la présentant comme un outil complémentaire plutôt qu\'un remplacement.' },
    ],
    expression: [
      'L\'IA peut-elle remplacer certaines fonctions de l\'enseignant ?',
    ],
    speaking: 'Analysez le rôle de l\'IA dans l\'éducation avec une position nuancée pendant 3 à 4 minutes.',
  },
  {
    id: 'nantes-centre-commercial',
    title: 'À Nantes, des riverains s\'opposent à l\'extension d\'un centre commercial',
    level: 'B2',
    theme: 'Urban development — Presse française (article simulé)',
    warmup: [
      'Le développement urbain doit-il primer sur la qualité de vie des habitants ?',
    ],
    text: `Depuis plusieurs mois, le projet d'extension du centre commercial Beaulieu suscite de vives réactions parmi les habitants du quartier. Présenté par la municipalité comme un levier de dynamisation économique, le chantier ne fait pourtant pas l'unanimité.

Samedi après-midi, plusieurs dizaines de riverains se sont rassemblés à proximité du site afin de faire entendre leurs inquiétudes. Selon eux, l'agrandissement prévu entraînerait une augmentation significative de la circulation, déjà jugée excessive aux heures de pointe.

Certains habitants redoutent également une dégradation du cadre de vie, évoquant la disparition d'espaces verts et une hausse des nuisances sonores. « Nous ne sommes pas opposés au développement, mais pas à n'importe quel prix », a déclaré une représentante du collectif mobilisé.

De son côté, la mairie affirme que des études d'impact ont été menées en amont et que des mesures compensatoires sont prévues. L'adjoint à l'urbanisme a rappelé que le projet avait été validé par le conseil municipal l'an dernier, après plusieurs phases de concertation.

Interrogée par la presse locale, la municipalité insiste sur la nécessité d'adapter la ville aux évolutions démographiques, tout en reconnaissant que des ajustements pourraient être envisagés.

Si le dialogue semble engagé, les opposants préviennent toutefois que, sans révision du projet, de nouvelles actions pourraient être menées dans les semaines à venir, laissant entrevoir un conflit encore ouvert.`,
    questions: [
      { q: 'Expliquez en quoi le projet est perçu différemment par la municipalité et les habitants.', a: 'La municipalité le présente comme un levier de dynamisation économique, tandis que les habitants y voient une menace pour leur cadre de vie (circulation, espaces verts, nuisances sonores).' },
      { q: 'Quels arguments les riverains avancent-ils pour justifier leur opposition ?', a: 'Augmentation de la circulation, disparition d\'espaces verts, hausse des nuisances sonores et dégradation du cadre de vie.' },
      { q: 'Que révèle l\'expression « pas à n\'importe quel prix » sur leur position ?', a: 'Elle montre que les riverains ne sont pas contre le développement en soi, mais refusent qu\'il se fasse au détriment de leur qualité de vie. C\'est une position nuancée, pas un rejet total.' },
      { q: 'Pourquoi peut-on dire que le conflit reste ouvert ?', a: 'Les opposants préviennent que sans révision du projet, de nouvelles actions pourraient être menées, ce qui laisse entrevoir une escalade possible.' },
      { q: 'Analysez la stratégie de communication adoptée par la mairie.', a: 'La mairie adopte une posture rassurante en rappelant les études d\'impact, les concertations passées et la validation démocratique du projet, tout en laissant la porte ouverte à des ajustements.' },
    ],
    expression: [
      'Racontez les événements qui ont conduit à la mobilisation des habitants (discours indirect recommandé).',
      'Expliquez ce qui pourrait se produire si le projet se poursuit sans modification.',
    ],
    speaking: 'Le développement urbain doit-il primer sur la qualité de vie ? Donnez une réponse nuancée pendant 3 à 4 minutes.',
  },
  {
    id: 'bretagne-quatre-jours',
    title: 'Une commune expérimente la semaine de quatre jours pour ses agents',
    level: 'B2',
    theme: 'Work reform — Presse française (article simulé)',
    warmup: [
      'La semaine de quatre jours est-elle applicable à tous les secteurs ?',
    ],
    text: `Depuis le début de l'année, la commune de Ploërmel a engagé une réflexion approfondie sur l'organisation du temps de travail de ses agents municipaux. Confrontée à des difficultés de recrutement et à une hausse de l'absentéisme, la municipalité a décidé de tester la semaine de quatre jours dans plusieurs services.

L'expérimentation, lancée au mois de mars, concerne une cinquantaine d'agents volontaires. Elle repose sur un allongement de la durée quotidienne de travail, sans réduction du volume hebdomadaire. Selon la mairie, cette mesure vise à améliorer l'équilibre entre vie professionnelle et vie personnelle tout en renforçant l'attractivité des postes.

Du côté des agents, les premiers retours apparaissent contrastés. Certains saluent une meilleure organisation de leur temps libre, tandis que d'autres évoquent une fatigue accrue en fin de journée.

Les syndicats, quant à eux, appellent à la prudence et demandent qu'un bilan précis soit réalisé avant toute décision de généralisation.

La municipalité rappelle que cette phase de test doit durer plusieurs mois et qu'un comité de suivi a été mis en place afin d'évaluer les effets du dispositif.

À terme, les élus devront se prononcer sur la poursuite ou non de cette organisation, qui suscite déjà l'intérêt d'autres collectivités territoriales.`,
    questions: [
      { q: 'Quels facteurs ont conduit à la mise en place de cette expérimentation ?', a: 'Des difficultés de recrutement et une hausse de l\'absentéisme parmi les agents municipaux.' },
      { q: 'Quels avantages et quelles limites sont évoqués par les différents acteurs ?', a: 'Avantages : meilleure organisation du temps libre, équilibre vie pro/perso, attractivité des postes. Limites : fatigue accrue en fin de journée, prudence des syndicats.' },
      { q: 'Pourquoi les syndicats adoptent-ils une position prudente ?', a: 'Ils demandent qu\'un bilan précis soit réalisé avant toute décision de généralisation, craignant des effets négatifs non mesurés.' },
      { q: 'Quel rôle joue le comité de suivi ?', a: 'Il a été mis en place pour évaluer les effets du dispositif pendant la phase de test, permettant une prise de décision fondée sur des données concrètes.' },
      { q: 'En quoi cette initiative pourrait-elle avoir une portée plus large ?', a: 'Elle suscite déjà l\'intérêt d\'autres collectivités territoriales, ce qui suggère qu\'elle pourrait servir de modèle si les résultats sont positifs.' },
    ],
    expression: [
      'Expliquez pourquoi et comment cette réforme a été mise en place.',
      'Analysez les résultats possibles de cette expérimentation et leurs conséquences.',
    ],
    speaking: 'La semaine de quatre jours est-elle applicable à tous les secteurs ? Justifiez votre réponse pendant 3 à 4 minutes.',
  },
  {
    id: 'bordeaux-pistes-cyclables',
    title: 'À Bordeaux, de nouvelles pistes cyclables divisent les habitants',
    level: 'B2',
    theme: 'Mobility & environment — Presse française (article simulé)',
    warmup: [
      'Faut-il limiter la place de la voiture en ville ?',
    ],
    text: `Depuis plusieurs mois, la métropole de Bordeaux a engagé un programme de développement des infrastructures cyclables afin de favoriser les mobilités douces. Présenté comme une réponse aux enjeux environnementaux, ce projet vise à encourager l'usage du vélo au quotidien.

Dans ce cadre, plusieurs axes routiers ont été réaménagés pour accueillir de nouvelles pistes cyclables sécurisées. Toutefois, ces transformations suscitent des réactions contrastées.

Certains commerçants dénoncent une réduction significative des places de stationnement, qu'ils jugent préjudiciable à leur activité. De leur côté, plusieurs automobilistes estiment que la circulation est devenue plus difficile, notamment aux heures de pointe.

À l'inverse, les associations de cyclistes saluent une avancée importante en matière de sécurité et de transition écologique, rappelant que ces aménagements étaient attendus depuis longtemps.

La municipalité, quant à elle, défend un projet nécessaire et affirme que des ajustements pourront être réalisés en fonction des retours des usagers.

Une phase d'évaluation est prévue dans les prochains mois afin de mesurer l'impact réel de ces transformations et d'éventuellement adapter les dispositifs existants.`,
    questions: [
      { q: 'Quel est l\'objectif principal du projet mis en place par la métropole ?', a: 'Favoriser les mobilités douces en développant les infrastructures cyclables, en réponse aux enjeux environnementaux.' },
      { q: 'Pourquoi certains acteurs économiques s\'y opposent-ils ?', a: 'Les commerçants dénoncent la réduction des places de stationnement, jugée préjudiciable à leur activité commerciale.' },
      { q: 'Analysez les tensions entre enjeux économiques et environnementaux.', a: 'D\'un côté, la transition écologique nécessite de repenser l\'espace urbain ; de l\'autre, les commerçants et automobilistes subissent des contraintes immédiates qui affectent leur quotidien et leur activité.' },
      { q: 'Que révèlent les différentes réactions des habitants ?', a: 'Elles révèlent une société divisée entre ceux qui privilégient la transition écologique et ceux qui défendent leurs intérêts économiques et leur confort de déplacement.' },
      { q: 'Pourquoi la municipalité prévoit-elle une phase d\'évaluation ?', a: 'Pour mesurer l\'impact réel des transformations et adapter les dispositifs si nécessaire, montrant une volonté de dialogue et d\'ajustement.' },
    ],
    expression: [
      'Décrivez la mise en place du projet et les réactions qu\'il a suscitées.',
      'Expliquez les évolutions possibles après la phase d\'évaluation.',
    ],
    speaking: 'Faut-il limiter la place de la voiture en ville ? Répondez de manière nuancée pendant 3 à 4 minutes.',
  },
  {
    id: 'afrique-paludisme',
    title: 'En Afrique de l\'Ouest, la lutte contre le paludisme confrontée à de nouveaux défis',
    level: 'B2',
    theme: 'Global health — Presse française (article simulé)',
    warmup: [
      'La lutte contre les maladies mondiales doit-elle être une priorité absolue ?',
    ],
    text: `Alors que plusieurs pays d'Afrique de l'Ouest avaient enregistré des progrès significatifs dans la lutte contre le paludisme ces dernières années, les autorités sanitaires observent aujourd'hui un ralentissement préoccupant.

Selon les spécialistes, cette situation s'explique par une combinaison de facteurs, notamment un accès encore limité aux soins dans certaines zones rurales, des conditions climatiques défavorables et des pénuries ponctuelles de traitements.

Dans certaines régions, les infrastructures de santé restent difficiles d'accès, en particulier pendant la saison des pluies, ce qui complique la prise en charge des patients.

Les experts alertent également sur l'apparition de résistances aux médicaments, susceptible de remettre en cause les progrès réalisés au cours de la dernière décennie.

Face à ces défis, les autorités sanitaires ont annoncé le renforcement des campagnes de prévention et le développement de partenariats avec des organisations internationales.

Malgré ces initiatives, les spécialistes estiment qu'une mobilisation durable et coordonnée sera indispensable pour contenir efficacement la maladie dans les années à venir.`,
    questions: [
      { q: 'Pourquoi parle-t-on d\'un ralentissement dans la lutte contre le paludisme ?', a: 'Malgré des progrès significatifs ces dernières années, les autorités sanitaires observent un ralentissement préoccupant dû à plusieurs facteurs combinés.' },
      { q: 'Quels facteurs expliquent les difficultés actuelles ?', a: 'Un accès limité aux soins en zones rurales, des conditions climatiques défavorables, des pénuries de traitements et l\'apparition de résistances aux médicaments.' },
      { q: 'En quoi les progrès passés sont-ils menacés ?', a: 'L\'apparition de résistances aux médicaments est susceptible de remettre en cause les progrès réalisés au cours de la dernière décennie.' },
      { q: 'Quel rôle jouent les actions internationales dans ce contexte ?', a: 'Les autorités développent des partenariats avec des organisations internationales pour renforcer les campagnes de prévention, montrant que la lutte dépasse le cadre national.' },
      { q: 'Pourquoi une mobilisation coordonnée est-elle essentielle ?', a: 'Parce que les défis sont multiples et interconnectés : seule une action durable et coordonnée entre pays et organisations peut contenir efficacement la maladie.' },
    ],
    expression: [
      'Expliquez l\'évolution de la situation du paludisme ces dernières années.',
      'Analysez les mesures possibles et leurs effets à long terme.',
    ],
    speaking: 'La lutte contre les maladies mondiales doit-elle être une priorité absolue ? Justifiez pendant 3 à 4 minutes.',
  },
  {
    id: 'infirmiers-systeme-hospitalier',
    title: 'Une profession sous tension : les infirmiers face à une transformation silencieuse du système hospitalier',
    level: 'B2',
    theme: 'Healthcare & society — Presse française (article simulé)',
    warmup: [
      'Les contraintes économiques peuvent-elles justifier une transformation progressive des métiers de la santé ?',
    ],
    text: `Depuis plusieurs années, les transformations successives du système hospitalier semblent avoir profondément modifié les conditions d'exercice des infirmiers, sans que ces évolutions ne fassent toujours l'objet d'un débat explicite. Si les tensions évoquées aujourd'hui ne sont pas inédites, leur intensification récente s'inscrit dans une dynamique plus large, où les logiques organisationnelles tendent à redéfinir, parfois de manière implicite, les contours du métier.

Dans de nombreux établissements, les impératifs de gestion et d'optimisation des ressources ont conduit à une réorganisation progressive du travail, dont les effets se manifestent à différents niveaux. À mesure que les contraintes administratives se renforcent, certains professionnels constatent une réduction du temps consacré à la relation avec les patients, pourtant considérée comme centrale dans leur engagement initial. Cette évolution, rarement formulée de manière frontale, alimente un sentiment diffus de décalage entre les représentations du métier et sa réalité quotidienne.

Parallèlement, les conditions matérielles d'exercice — marquées par des horaires irréguliers, des effectifs parfois insuffisants et une pression temporelle constante — semblent contribuer à une forme de fatigue qui dépasse la seule dimension physique. Plusieurs témoignages évoquent ainsi une usure progressive, liée moins à l'intensité ponctuelle du travail qu'à son caractère continu et difficilement prévisible. Dans ce contexte, la question du maintien de la qualité des soins se pose de manière indirecte, sans pour autant faire l'objet d'un consensus clair.

Du côté des institutions, les réponses apportées mettent souvent en avant la complexité des arbitrages budgétaires et la nécessité d'adapter le fonctionnement hospitalier à des contraintes croissantes. Si certaines mesures ont été annoncées afin d'améliorer l'attractivité du métier, leur portée réelle reste discutée, notamment en raison de leur caractère partiel. Pour certains observateurs, ces ajustements, bien qu'indispensables, ne permettraient pas de répondre aux causes structurelles des difficultés rencontrées.

Dans ce contexte, la situation des infirmiers apparaît comme révélatrice de tensions plus larges, qui traversent l'ensemble du système de santé. Sans qu'une orientation claire ne se dégage, les évolutions en cours laissent entrevoir des transformations dont les effets, encore difficiles à mesurer, pourraient s'inscrire dans la durée.`,
    questions: [
      { q: 'En quoi les difficultés des infirmiers s\'inscrivent-elles dans une transformation plus globale du système hospitalier ?', a: 'Les logiques organisationnelles et les impératifs de gestion redéfinissent les contours du métier, réduisant le temps consacré aux patients et créant un décalage entre les représentations du métier et sa réalité.' },
      { q: 'Comment le texte suggère-t-il une évolution du rôle des infirmiers sans l\'énoncer directement ?', a: 'Par des formulations prudentes (« semblent », « de manière implicite », « rarement formulée ») qui décrivent une transformation progressive sans la présenter comme un fait accompli.' },
      { q: 'Que signifie le « décalage » entre les attentes initiales et la réalité du métier ?', a: 'Les infirmiers s\'engagent pour la relation avec les patients, mais les contraintes administratives et organisationnelles réduisent ce temps relationnel, créant une distance entre l\'idéal professionnel et le quotidien.' },
      { q: 'Pourquoi la question de la qualité des soins est-elle abordée de manière indirecte ?', a: 'Parce qu\'il n\'existe pas de consensus clair sur ce sujet ; le texte suggère que la fatigue et le manque de temps pourraient affecter les soins sans l\'affirmer catégoriquement.' },
      { q: 'En quoi le texte reste-t-il volontairement ouvert ou non conclusif ?', a: 'Il utilise des formulations nuancées et conditionnelles, ne propose pas de solution définitive et souligne que les effets des transformations sont « encore difficiles à mesurer ».' },
    ],
    expression: [
      'Expliquez comment les transformations du système hospitalier ont progressivement conduit à la situation actuelle.',
      'Analysez les évolutions possibles si les tendances actuelles se poursuivent.',
    ],
    speaking: 'Les contraintes économiques peuvent-elles justifier une transformation progressive des métiers de la santé ? Développez une réponse nuancée pendant 3 à 4 minutes.',
  },
  {
    id: 'etudes-medecine',
    title: 'Des études de médecine entre exigence académique et adaptation progressive à un système en mutation',
    level: 'B2',
    theme: 'Education & medicine — Presse française (article simulé)',
    warmup: [
      'Le niveau d\'exigence des études de médecine est-il justifié malgré ses effets sur les étudiants ?',
    ],
    text: `Si les études de médecine ont longtemps été associées à une forme d'excellence académique reposant sur la rigueur et la sélection, plusieurs évolutions récentes semblent en modifier progressivement les contours, sans pour autant en atténuer la difficulté. Derrière l'image d'un parcours exigeant mais structuré, se dessine une réalité plus nuancée, marquée par une intensification des contraintes et une diversification des trajectoires.

Dès les premières années, les étudiants se trouvent confrontés à un volume de travail considérable, dont la maîtrise repose autant sur l'acquisition de connaissances que sur la capacité à s'adapter à un rythme soutenu. Si la sélection demeure un élément central du système, elle ne s'opère plus uniquement à travers des mécanismes formels, mais s'inscrit également dans une logique de performance continue, où la régularité et l'endurance jouent un rôle déterminant. Cette évolution, bien que rarement formulée explicitement, contribue à installer un climat de compétition diffuse, dont les effets varient selon les profils.

Par ailleurs, la formation médicale ne se limite pas à une accumulation de savoirs théoriques. Elle implique une confrontation progressive à des situations cliniques, parfois complexes, qui exigent des capacités d'adaptation et une gestion de l'incertitude. Pour certains étudiants, cette transition entre théorie et pratique peut s'avérer déstabilisante, dans la mesure où elle remet en question des repères construits dans un cadre académique plus prévisible. Ainsi, la difficulté du parcours ne réside pas uniquement dans son intensité, mais aussi dans la nature évolutive des compétences attendues.

Les réformes engagées ces dernières années, visant notamment à diversifier les voies d'accès aux études de médecine, ont introduit de nouvelles dynamiques, sans pour autant supprimer les tensions existantes. Si elles ont permis d'ouvrir le système à des profils plus variés, elles ont également contribué à complexifier les parcours, rendant leur lisibilité parfois plus incertaine. Dans ce contexte, certains observateurs s'interrogent sur la capacité de ces transformations à concilier équité d'accès et maintien d'un haut niveau d'exigence.

Entre impératif de qualité et prise en compte du bien-être des étudiants, la formation médicale semble ainsi évoluer dans un équilibre fragile. Sans remettre en cause ses fondements, les ajustements en cours laissent apparaître des interrogations persistantes quant à leur impact à long terme, tant sur les futurs professionnels que sur le système de santé dans son ensemble.`,
    questions: [
      { q: 'En quoi les études de médecine ne se limitent-elles pas à une simple sélection académique ?', a: 'Elles impliquent aussi une logique de performance continue, une confrontation à des situations cliniques complexes et une gestion de l\'incertitude, au-delà de la seule acquisition de connaissances.' },
      { q: 'Comment la notion de « performance continue » est-elle suggérée dans le texte ?', a: 'La sélection ne s\'opère plus uniquement par des mécanismes formels mais par la régularité et l\'endurance, installant un climat de compétition diffuse.' },
      { q: 'Pourquoi la transition entre théorie et pratique peut-elle être déstabilisante pour les étudiants ?', a: 'Elle remet en question des repères construits dans un cadre académique prévisible en confrontant les étudiants à des situations cliniques incertaines et complexes.' },
      { q: 'En quoi les réformes récentes ont-elles complexifié le système plutôt que de le simplifier ?', a: 'Elles ont ouvert l\'accès à des profils plus variés mais ont rendu les parcours moins lisibles, sans supprimer les tensions existantes entre équité et exigence.' },
      { q: 'Quelle tension principale structure l\'ensemble du texte ?', a: 'La tension entre l\'impératif de qualité et d\'exigence académique d\'une part, et la prise en compte du bien-être des étudiants d\'autre part.' },
    ],
    expression: [
      'Expliquez comment les études de médecine ont évolué ces dernières années et quels changements ont affecté les étudiants.',
      'Analysez les évolutions possibles du système de formation médicale et leurs conséquences.',
    ],
    speaking: 'Le niveau d\'exigence des études de médecine est-il justifié malgré ses effets sur les étudiants ? Développez une réponse nuancée pendant 3 à 4 minutes.',
  },
  {
    id: 'pression-etudiants-famille',
    title: 'Entre attentes implicites et construction personnelle, des étudiants face à une pression difficile à formuler',
    level: 'B2',
    theme: 'Student life & family — Presse française (article simulé)',
    warmup: [
      'Les attentes familiales sont-elles un facteur de réussite ou une source de pression excessive ?',
    ],
    text: `Dans un contexte marqué par une intensification des parcours académiques et une incertitude croissante quant aux débouchés professionnels, la question des attentes familiales occupe une place de plus en plus visible dans le discours des étudiants. Si ces attentes ne se traduisent pas toujours par des injonctions explicites, elles semblent néanmoins structurer, de manière diffuse, les choix et les trajectoires individuelles.

Pour certains, l'investissement dans les études ne relève pas uniquement d'une ambition personnelle, mais s'inscrit dans une logique de responsabilité vis-à-vis d'un cadre familial qui a souvent mobilisé des ressources importantes. Cette dimension, rarement remise en cause ouvertement, peut contribuer à installer une forme de pression intériorisée, d'autant plus difficile à exprimer qu'elle se confond avec des objectifs perçus comme légitimes. Ainsi, la réussite tend à devenir une norme implicite, dont l'éventuelle remise en question apparaît comme problématique.

Par ailleurs, la diversité des parcours universitaires ne garantit pas nécessairement une réduction de cette pression. Au contraire, la multiplication des choix possibles peut renforcer un sentiment d'incertitude, dans la mesure où chaque décision engage une part de responsabilité individuelle. Dans ce contexte, certains étudiants évoquent une difficulté à concilier attentes extérieures et aspirations personnelles, sans toujours disposer des outils nécessaires pour arbitrer entre ces deux dimensions.

Les professionnels de l'accompagnement universitaire observent, de leur côté, une augmentation des situations d'anxiété liées à ces tensions. Ils soulignent que la pression ressentie ne résulte pas uniquement des exigences académiques, mais d'un ensemble de facteurs imbriqués, parmi lesquels la relation à la famille occupe une place centrale. Toutefois, cette relation ne peut être réduite à une simple source de contrainte, dans la mesure où elle constitue également un soutien essentiel pour de nombreux étudiants.

Dans ce cadre, la question de l'équilibre entre accompagnement et autonomie demeure largement ouverte. Si une prise de conscience semble émerger, les modalités concrètes d'un ajustement restent encore incertaines, laissant apparaître des tensions appelées à perdurer.`,
    questions: [
      { q: 'Comment les attentes familiales influencent-elles les choix des étudiants sans être explicitement imposées ?', a: 'Elles structurent de manière diffuse les trajectoires, créant une pression intériorisée qui se confond avec des objectifs perçus comme légitimes, rendant la réussite une norme implicite.' },
      { q: 'Pourquoi la pression est-elle difficile à exprimer selon le texte ?', a: 'Parce qu\'elle se confond avec des objectifs perçus comme légitimes et qu\'elle est liée à un investissement familial important, rendant sa remise en question problématique.' },
      { q: 'En quoi la multiplicité des choix peut-elle renforcer l\'incertitude ?', a: 'Chaque décision engage une responsabilité individuelle, et la diversité des parcours ne réduit pas la pression mais ajoute l\'angoisse de faire le « bon » choix.' },
      { q: 'Quel paradoxe apparaît dans le rôle de la famille ?', a: 'La famille est à la fois source de pression (attentes implicites, investissement) et soutien essentiel pour les étudiants — elle ne peut être réduite à une simple contrainte.' },
      { q: 'Pourquoi le texte ne propose-t-il pas de solution claire ?', a: 'Parce que les modalités d\'ajustement restent incertaines et que les tensions sont appelées à perdurer, le texte reflétant la complexité du sujet sans simplification.' },
    ],
    expression: [
      'Expliquez comment cette pression s\'est progressivement installée chez les étudiants.',
      'Analysez les évolutions possibles si les relations familiales évoluent.',
    ],
    speaking: 'Les attentes familiales sont-elles un facteur de réussite ou une source de pression excessive ? Développez pendant 3 à 4 minutes.',
  },
  {
    id: 'carriere-musicale',
    title: 'Entre vocation artistique et incertitude économique, une carrière musicale aux équilibres fragiles',
    level: 'B2',
    theme: 'Arts & economics — Presse française (article simulé)',
    warmup: [
      'Peut-on concilier passion artistique et sécurité financière ?',
    ],
    text: `Souvent perçue à travers le prisme de la passion et de l'expression personnelle, la carrière musicale apparaît, dans sa réalité concrète, marquée par une instabilité qui en constitue l'un des traits les plus persistants. Si l'idéal artistique continue d'exercer une forte attractivité, les conditions matérielles d'exercice du métier tendent à en complexifier considérablement l'accès et la pérennité.

Dans les premières phases de leur parcours, de nombreux musiciens évoluent dans un environnement caractérisé par la fragmentation des activités. Entre projets personnels, collaborations ponctuelles et activités annexes, la construction d'une trajectoire cohérente repose souvent sur une capacité d'adaptation constante. Cette diversité d'expériences, si elle peut être enrichissante sur le plan artistique, ne garantit pas pour autant une stabilisation économique, laissant apparaître une tension durable entre création et subsistance.

Par ailleurs, les mécanismes de reconnaissance dans le secteur musical demeurent en grande partie imprévisibles. La visibilité d'un artiste dépend de facteurs multiples — réseaux professionnels, exposition médiatique, réception du public — dont la combinaison échappe souvent à toute planification. Dans ce contexte, la notion de réussite apparaît relative, dans la mesure où elle ne se réduit pas à des critères objectifs et peut varier selon les trajectoires individuelles.

Face à cette incertitude, certains musiciens développent des stratégies visant à diversifier leurs sources de revenus, sans que ces ajustements ne permettent toujours d'assurer une sécurité durable. Cette situation conduit à interroger la viabilité à long terme d'un modèle reposant largement sur la précarité, tout en soulignant la difficulté de concilier exigences artistiques et contraintes économiques.

Ainsi, la carrière musicale se construit dans un équilibre instable, où la poursuite d'un idéal coexiste avec des réalités matérielles parfois contraignantes, sans qu'une solution unique ne s'impose.`,
    questions: [
      { q: 'Pourquoi la carrière musicale est-elle structurellement instable ?', a: 'Elle est marquée par la fragmentation des activités, l\'imprévisibilité de la reconnaissance et une tension durable entre création artistique et subsistance économique.' },
      { q: 'Quels éléments rendent la réussite difficile à prévoir ?', a: 'La visibilité dépend de facteurs multiples (réseaux, médias, public) dont la combinaison échappe à toute planification, rendant la réussite relative et variable.' },
      { q: 'Que signifie la relativité de la réussite dans ce contexte ?', a: 'La réussite ne se réduit pas à des critères objectifs (ventes, notoriété) mais varie selon les trajectoires individuelles et les définitions personnelles du succès.' },
      { q: 'Comment les musiciens tentent-ils de s\'adapter ?', a: 'Ils diversifient leurs sources de revenus entre projets personnels, collaborations ponctuelles et activités annexes, sans toujours garantir une sécurité durable.' },
      { q: 'Quelle tension principale traverse le texte ?', a: 'La tension entre la poursuite d\'un idéal artistique et les réalités matérielles contraignantes, entre passion et précarité économique.' },
    ],
    expression: [
      'Décrivez l\'évolution du parcours d\'un musicien débutant.',
      'Analysez les transformations possibles du secteur musical.',
    ],
    speaking: 'Peut-on concilier passion artistique et sécurité financière ? Développez pendant 3 à 4 minutes.',
  },
  {
    id: 'pauvrete-burkina-faso',
    title: 'Entre contraintes structurelles et dynamiques locales, une pauvreté persistante aux causes multiples',
    level: 'B2',
    theme: 'Development & economics — Presse française (article simulé)',
    warmup: [
      'Les politiques de développement doivent-elles être globales ou adaptées localement ?',
    ],
    text: `Malgré la mise en œuvre de nombreux programmes de développement au cours des dernières décennies, la situation économique du Burkina Faso demeure marquée par des inégalités persistantes, particulièrement visibles dans les zones rurales. Si certaines initiatives ont permis des améliorations ponctuelles, leurs effets apparaissent souvent limités par des contraintes structurelles qui en freinent la portée.

Parmi ces contraintes, l'accès inégal aux infrastructures essentielles — éducation, santé, transport — constitue un facteur déterminant. Dans plusieurs régions, ces insuffisances rendent difficile l'émergence de dynamiques économiques durables, en limitant les opportunités locales. À cela s'ajoutent des facteurs extérieurs, tels que les variations climatiques, qui affectent directement les activités agricoles dont dépend une grande partie de la population.

L'instabilité sécuritaire, également évoquée par plusieurs observateurs, contribue à renforcer cette fragilité en perturbant les activités économiques et en compliquant la mise en œuvre des politiques publiques. Dans ce contexte, les interventions internationales, bien que nombreuses, produisent des résultats inégaux, souvent difficiles à évaluer sur le long terme.

Certains experts soulignent que ces limites tiennent en partie à un décalage entre les stratégies mises en œuvre et les réalités locales. Les approches standardisées, conçues à une échelle globale, peinent parfois à prendre en compte la diversité des situations rencontrées sur le terrain. Cette observation alimente un débat sur la nécessité d'adapter les politiques de développement aux contextes spécifiques.

Ainsi, la persistance de la pauvreté ne peut être attribuée à une cause unique, mais résulte d'un ensemble de facteurs interdépendants, dont la complexité rend toute réponse univoque difficile.`,
    questions: [
      { q: 'Pourquoi les programmes de développement ont-ils des effets limités ?', a: 'Leurs effets sont freinés par des contraintes structurelles : accès inégal aux infrastructures, variations climatiques, instabilité sécuritaire et décalage entre stratégies globales et réalités locales.' },
      { q: 'Que recouvrent les « contraintes structurelles » mentionnées ?', a: 'L\'accès inégal aux infrastructures essentielles (éducation, santé, transport), les facteurs climatiques affectant l\'agriculture et l\'instabilité sécuritaire.' },
      { q: 'Quel rôle jouent les facteurs climatiques et sécuritaires ?', a: 'Les variations climatiques affectent les activités agricoles dont dépend la population, et l\'instabilité sécuritaire perturbe l\'économie et complique la mise en œuvre des politiques publiques.' },
      { q: 'Pourquoi les stratégies internationales sont-elles critiquées ?', a: 'Elles sont conçues à une échelle globale et peinent à prendre en compte la diversité des situations locales, produisant des résultats inégaux et difficiles à évaluer.' },
      { q: 'En quoi la pauvreté est-elle présentée comme un phénomène complexe ?', a: 'Elle résulte d\'un ensemble de facteurs interdépendants (structurels, climatiques, sécuritaires, stratégiques) et ne peut être attribuée à une cause unique.' },
    ],
    expression: [
      'Expliquez l\'évolution de la situation économique.',
      'Analysez les solutions possibles à long terme.',
    ],
    speaking: 'Les politiques de développement doivent-elles être globales ou adaptées localement ? Développez pendant 3 à 4 minutes.',
  },
  {
    id: 'immigration-canada',
    title: 'Entre attractivité et limites d\'intégration, un modèle migratoire confronté à ses propres tensions',
    level: 'B2',
    theme: 'Immigration & society — Presse française (article simulé)',
    warmup: [
      'Un modèle d\'immigration peut-il être à la fois ouvert et équilibré ?',
    ],
    text: `Souvent présenté comme un modèle d'ouverture en matière d'immigration, le Canada continue d'attirer un nombre important de candidats en quête d'opportunités économiques et d'un cadre de vie stable. Toutefois, derrière cette image largement positive, certaines difficultés liées aux processus d'intégration tendent à apparaître de manière plus visible.

L'un des enjeux majeurs concerne la reconnaissance des qualifications obtenues à l'étranger. Pour de nombreux immigrés, les démarches nécessaires à leur validation s'avèrent longues et incertaines, pouvant conduire à des situations de déclassement professionnel. Cette réalité, bien que documentée, est parfois atténuée dans le discours institutionnel, qui met en avant les dispositifs d'accompagnement existants.

Au-delà de la dimension professionnelle, l'intégration implique également des ajustements d'ordre social et culturel, dont la réussite dépend de facteurs multiples. Ces processus, souvent progressifs, ne peuvent être entièrement anticipés et varient selon les trajectoires individuelles. Dans ce contexte, certains témoignages évoquent un décalage entre les attentes initiales et les expériences vécues.

Les politiques publiques cherchent à répondre à ces enjeux en proposant des mécanismes de soutien, dont l'efficacité reste toutefois variable. Si certains parcours d'intégration illustrent la réussite du modèle canadien, d'autres mettent en évidence ses limites, sans pour autant remettre en cause ses principes fondamentaux.

Ainsi, le modèle migratoire canadien apparaît à la fois comme un espace d'opportunités et comme un système confronté à des tensions internes, dont l'évolution dépendra des ajustements à venir.`,
    questions: [
      { q: 'Pourquoi le modèle canadien est-il à la fois attractif et critiqué ?', a: 'Il attire par ses opportunités économiques et son cadre de vie, mais présente des difficultés d\'intégration liées à la reconnaissance des qualifications et aux ajustements socioculturels.' },
      { q: 'Que signifie le déclassement professionnel ?', a: 'C\'est la situation où des immigrés qualifiés occupent des postes inférieurs à leur niveau de compétences, faute de reconnaissance de leurs diplômes étrangers.' },
      { q: 'Pourquoi l\'intégration dépasse-t-elle la dimension économique ?', a: 'Elle implique aussi des ajustements sociaux et culturels progressifs qui varient selon les individus et ne peuvent être entièrement anticipés.' },
      { q: 'Quel décalage est évoqué dans le texte ?', a: 'Un décalage entre les attentes initiales des immigrés (image positive du Canada) et les expériences vécues (difficultés de reconnaissance, déclassement, ajustements culturels).' },
      { q: 'Pourquoi le modèle n\'est-il pas totalement remis en cause ?', a: 'Parce que certains parcours illustrent sa réussite et que ses principes fondamentaux d\'ouverture restent valides, même si des limites sont reconnues.' },
    ],
    expression: [
      'Expliquez l\'évolution des politiques d\'immigration.',
      'Analysez les ajustements possibles du système.',
    ],
    speaking: 'Un modèle d\'immigration peut-il être à la fois ouvert et équilibré ? Développez pendant 3 à 4 minutes.',
  },
  {
    id: 'bilan-carbone',
    title: 'Le bilan carbone, un outil encore mal compris du grand public',
    level: 'B1',
    theme: 'Environment & climate — Presse française (article simulé)',
    warmup: [
      'Pensez-vous que les individus peuvent vraiment agir pour l\'environnement ?',
    ],
    text: `Depuis plusieurs années, le bilan carbone est présenté comme un outil essentiel pour mesurer l'impact des activités humaines sur l'environnement. Il permet d'évaluer la quantité de gaz à effet de serre produite par une personne, une entreprise ou un pays.

Malgré son importance, ce concept reste encore difficile à comprendre pour une grande partie du public. Beaucoup de citoyens associent le bilan carbone uniquement aux transports, sans prendre en compte d'autres éléments comme l'alimentation, la consommation d'énergie ou les achats quotidiens.

Pour améliorer cette situation, certaines associations organisent des campagnes de sensibilisation. Elles proposent des outils simples pour aider les gens à calculer leur propre empreinte carbone.

Cependant, ces initiatives rencontrent parfois des limites. Certains participants trouvent les résultats complexes ou ont du mal à changer leurs habitudes.

Les spécialistes estiment donc qu'il est nécessaire de mieux expliquer ce concept, mais aussi de proposer des solutions concrètes pour réduire son impact au quotidien.`,
    questions: [
      { q: 'À quoi sert le bilan carbone ?', a: 'Il permet de mesurer l\'impact des activités humaines sur l\'environnement en évaluant la quantité de gaz à effet de serre produite.' },
      { q: 'Pourquoi est-il difficile à comprendre pour le public ?', a: 'Beaucoup de citoyens l\'associent uniquement aux transports, sans prendre en compte l\'alimentation, l\'énergie ou les achats quotidiens.' },
      { q: 'Quelles solutions sont proposées pour informer les citoyens ?', a: 'Des associations organisent des campagnes de sensibilisation et proposent des outils simples pour calculer son empreinte carbone.' },
      { q: 'Quelles limites sont mentionnées ?', a: 'Certains participants trouvent les résultats complexes ou ont du mal à changer leurs habitudes.' },
      { q: 'Pourquoi faut-il aller au-delà de l\'information ?', a: 'Parce qu\'il ne suffit pas d\'expliquer le concept : il faut aussi proposer des solutions concrètes pour réduire son impact au quotidien.' },
    ],
    expression: [
      'Expliquez comment le bilan carbone est devenu important.',
      'Imaginez comment les citoyens pourraient réduire leur impact.',
    ],
    speaking: 'Pensez-vous que les individus peuvent vraiment agir pour l\'environnement ? Développez pendant 2 à 3 minutes.',
  },
  {
    id: 'energie-solaire',
    title: 'L\'énergie solaire attire de nouveaux acteurs mais pose encore des défis',
    level: 'B1',
    theme: 'Energy & innovation — Presse française (article simulé)',
    warmup: [
      'L\'énergie solaire peut-elle remplacer les autres sources d\'énergie ?',
    ],
    text: `Face aux enjeux climatiques, l'énergie solaire connaît un développement rapide dans de nombreux pays. De nouvelles entreprises se lancent dans la fabrication de panneaux solaires, attirées par la croissance du marché.

Selon certains responsables du secteur, cette évolution représente une opportunité importante pour produire une énergie plus propre. Les progrès technologiques permettent aujourd'hui d'améliorer l'efficacité des installations.

Cependant, les fabricants soulignent aussi plusieurs difficultés. Le coût de production reste élevé, et la concurrence internationale est forte. De plus, l'installation des équipements dépend souvent des politiques publiques et des aides financières.

Dans une interview récente, un dirigeant explique que le principal défi consiste à rendre cette énergie accessible à tous. Il insiste également sur la nécessité de former des professionnels qualifiés.

Malgré ces obstacles, le secteur continue de se développer, soutenu par une demande croissante.`,
    questions: [
      { q: 'Pourquoi l\'énergie solaire se développe-t-elle ?', a: 'Face aux enjeux climatiques, de nouvelles entreprises se lancent dans la fabrication de panneaux solaires, attirées par la croissance du marché.' },
      { q: 'Quels avantages sont mentionnés ?', a: 'L\'énergie solaire permet de produire une énergie plus propre et les progrès technologiques améliorent l\'efficacité des installations.' },
      { q: 'Quelles difficultés rencontrent les fabricants ?', a: 'Le coût de production reste élevé, la concurrence internationale est forte et l\'installation dépend des politiques publiques et des aides financières.' },
      { q: 'Quel est le principal défi selon l\'interview ?', a: 'Rendre l\'énergie solaire accessible à tous et former des professionnels qualifiés.' },
      { q: 'Pourquoi ce secteur continue-t-il à progresser ?', a: 'Parce qu\'il est soutenu par une demande croissante liée aux enjeux climatiques.' },
    ],
    expression: [
      'Décrivez le développement de l\'énergie solaire.',
      'Expliquez comment ce secteur pourrait évoluer.',
    ],
    speaking: 'L\'énergie solaire peut-elle remplacer les autres sources d\'énergie ? Développez pendant 2 à 3 minutes.',
  },
  {
    id: 'recyclage-alimentaire',
    title: 'En France, les restaurants doivent désormais mieux gérer leurs déchets alimentaires',
    level: 'B1',
    theme: 'Society & environment — Presse française (article simulé)',
    warmup: [
      'Faut-il obliger les entreprises à protéger l\'environnement ?',
    ],
    text: `Depuis quelques années, les autorités françaises ont mis en place des mesures pour réduire le gaspillage alimentaire. Les restaurants sont désormais encouragés, et parfois obligés, à trier et recycler leurs déchets.

Cette initiative vise à limiter l'impact environnemental du secteur de la restauration, qui produit une grande quantité de déchets chaque jour. Certains établissements ont déjà adopté des solutions comme le compost ou le don des invendus.

Cependant, tous les professionnels ne sont pas convaincus. Certains restaurateurs estiment que ces nouvelles règles demandent du temps et des investissements supplémentaires.

De leur côté, les autorités expliquent que ces efforts sont nécessaires pour répondre aux enjeux écologiques. Elles proposent également des aides pour accompagner les établissements.

Malgré les difficultés, cette politique commence à modifier les pratiques dans le secteur.`,
    questions: [
      { q: 'Pourquoi ces mesures ont-elles été mises en place ?', a: 'Pour réduire le gaspillage alimentaire et limiter l\'impact environnemental du secteur de la restauration.' },
      { q: 'Quelles solutions utilisent certains restaurants ?', a: 'Certains établissements ont adopté le compost ou le don des invendus.' },
      { q: 'Pourquoi certains professionnels sont-ils réticents ?', a: 'Ils estiment que les nouvelles règles demandent du temps et des investissements supplémentaires.' },
      { q: 'Comment les autorités justifient-elles ces règles ?', a: 'Elles expliquent que ces efforts sont nécessaires pour répondre aux enjeux écologiques et proposent des aides pour accompagner les établissements.' },
      { q: 'Quels effets observe-t-on déjà ?', a: 'Cette politique commence à modifier les pratiques dans le secteur de la restauration.' },
    ],
    expression: [
      'Expliquez comment les pratiques ont changé.',
      'Imaginez l\'évolution de la gestion des déchets.',
    ],
    speaking: 'Faut-il obliger les entreprises à protéger l\'environnement ? Développez pendant 2 à 3 minutes.',
  },
  {
    id: 'ecrans-jeunes-eleves',
    title: 'Vers une limitation des écrans chez les jeunes élèves ?',
    level: 'B1',
    theme: 'Education & technology — Presse française (article simulé)',
    warmup: [
      'Faut-il interdire les écrans aux enfants ? Pourquoi ?',
    ],
    text: `Dans plusieurs pays, comme l'Australie ou la France, le débat sur l'utilisation des écrans chez les enfants prend de plus en plus d'importance. Certains responsables proposent de limiter l'usage des écrans à l'école, voire de les interdire avant un certain âge.

Cette proposition repose sur des études qui montrent les effets négatifs d'une exposition excessive, notamment sur la concentration et le sommeil.

Cependant, tous les spécialistes ne sont pas d'accord. Certains pensent que les outils numériques peuvent être utiles s'ils sont bien utilisés.

Les enseignants, quant à eux, doivent trouver un équilibre entre innovation pédagogique et protection des élèves.

Pour l'instant, aucune décision générale n'a été prise, mais le débat continue dans plusieurs pays.`,
    questions: [
      { q: 'Pourquoi le débat sur les écrans existe-t-il ?', a: 'Parce que l\'utilisation des écrans chez les enfants prend de plus en plus d\'importance et que certains responsables proposent de la limiter ou de l\'interdire.' },
      { q: 'Quels risques sont mentionnés ?', a: 'Les effets négatifs d\'une exposition excessive sur la concentration et le sommeil des enfants.' },
      { q: 'Pourquoi certains experts ne sont-ils pas d\'accord ?', a: 'Certains pensent que les outils numériques peuvent être utiles s\'ils sont bien utilisés.' },
      { q: 'Quel rôle jouent les enseignants ?', a: 'Ils doivent trouver un équilibre entre innovation pédagogique et protection des élèves.' },
      { q: 'Pourquoi le débat reste-t-il ouvert ?', a: 'Parce qu\'aucune décision générale n\'a été prise et que les avis des spécialistes divergent.' },
    ],
    expression: [
      'Expliquez comment l\'usage des écrans a évolué.',
      'Imaginez les règles possibles dans les écoles.',
    ],
    speaking: 'Faut-il interdire les écrans aux enfants ? Développez votre opinion pendant 2 à 3 minutes.',
  },
  {
    id: 'ma-famille-et-moi',
    title: 'Ma famille et moi',
    level: 'A1',
    theme: 'Family & home',
    warmup: [
      'Combien de personnes y a-t-il dans votre famille ?',
      'Habitez-vous avec votre famille ?',
      'Que faites-vous ensemble le week-end ?',
    ],
    text: `Je m'appelle Léa. J'ai 25 ans. J'habite à Strasbourg avec ma famille. Ma famille n'est pas très grande : il y a mon père, ma mère, mon frère et moi.

Mon père s'appelle Marc. Il a 55 ans. Il est ingénieur. Il travaille dans une grande entreprise. Il part tôt le matin et rentre vers 18 heures. Le soir, il aime regarder les informations à la télévision.

Ma mère s'appelle Catherine. Elle a 52 ans. Elle est professeure de français dans un collège. Elle adore lire et elle a beaucoup de livres à la maison. Le week-end, elle fait souvent de la pâtisserie. Ses gâteaux au chocolat sont délicieux !

Mon frère, Hugo, a 20 ans. Il est étudiant en informatique à l'université. Il aime les jeux vidéo et la musique. Il joue de la guitare dans un petit groupe avec ses amis.

Le dimanche, nous déjeunons souvent ensemble à la maison. Ma mère prépare un bon repas et nous parlons de notre semaine. C'est un moment que j'aime beaucoup. Ma famille est simple, mais nous sommes heureux ensemble.`,
    questions: [
      { q: 'Où habite Léa ?', a: 'Léa habite à Strasbourg avec sa famille.' },
      { q: 'Quel est le métier du père de Léa ?', a: 'Son père est ingénieur.' },
      { q: 'Que fait la mère de Léa le week-end ?', a: 'Elle fait souvent de la pâtisserie.' },
      { q: 'Qu\'étudie Hugo ?', a: 'Hugo étudie l\'informatique à l\'université.' },
      { q: 'Que fait la famille le dimanche ?', a: 'Ils déjeunent souvent ensemble à la maison.' },
      { q: 'Vrai ou faux : La famille de Léa est très grande.', a: 'Faux — sa famille n\'est pas très grande : quatre personnes.' },
    ],
    expression: [
      'Présentez les membres de votre famille.',
      'Que faites-vous ensemble le week-end ?',
      'Décrivez un moment que vous aimez passer en famille.',
    ],
    speaking: 'Présentez votre famille en français : les noms, les âges, les métiers et ce que vous aimez faire ensemble.',
  },
  {
    id: 'sortie-entre-amis',
    title: 'Une sortie entre amis',
    level: 'A1',
    theme: 'Friends & outings',
    warmup: [
      'Que faites-vous avec vos amis ?',
      'Où aimez-vous sortir le week-end ?',
      'Avez-vous un endroit préféré pour retrouver vos amis ?',
    ],
    text: `Samedi dernier, je suis sorti avec mes amis. Nous sommes allés au parc près de la rivière. Il faisait beau et chaud. C'était une journée parfaite pour sortir.

D'abord, nous avons fait un pique-nique. J'ai apporté des sandwichs au jambon et du jus d'orange. Mon ami Karim a apporté des fruits — des fraises et des cerises. Notre amie Julie a fait un gâteau au citron. C'était très bon !

Après le pique-nique, nous avons joué au football dans l'herbe. Karim est très bon au football, mais Julie et moi, nous préférons le badminton. Nous avons beaucoup ri ensemble.

L'après-midi, nous nous sommes promenés au bord de la rivière. L'eau était très claire. Nous avons pris des photos et nous avons parlé de nos vacances.

À 18 heures, nous sommes rentrés chez nous. J'étais fatigué mais très content. C'était une journée simple et agréable. J'adore passer du temps avec mes amis.`,
    questions: [
      { q: 'Où sont allés les amis ?', a: 'Ils sont allés au parc près de la rivière.' },
      { q: 'Quel temps faisait-il ?', a: 'Il faisait beau et chaud.' },
      { q: 'Qu\'est-ce que Karim a apporté ?', a: 'Il a apporté des fruits — des fraises et des cerises.' },
      { q: 'Qu\'ont-ils fait après le pique-nique ?', a: 'Ils ont joué au football dans l\'herbe.' },
      { q: 'Que préfèrent Julie et le narrateur ?', a: 'Ils préfèrent le badminton.' },
      { q: 'Vrai ou faux : Ils sont rentrés à midi.', a: 'Faux — ils sont rentrés à 18 heures.' },
    ],
    expression: [
      'Racontez une sortie avec vos amis.',
      'Quel est votre sport ou jeu préféré avec vos amis ?',
      'Décrivez un pique-nique idéal.',
    ],
    speaking: 'Racontez une sortie avec vos amis : où vous êtes allés, ce que vous avez fait et ce que vous avez mangé.',
  },
  {
    id: 'voyager-en-france',
    title: 'Voyager en France',
    level: 'A1',
    theme: 'Travel & transport',
    warmup: [
      'Aimez-vous voyager ?',
      'Quel moyen de transport préférez-vous ?',
      'Avez-vous déjà visité un autre pays ?',
    ],
    text: `La France est un beau pays pour voyager. Il y a beaucoup de villes intéressantes et de beaux paysages.

Pour voyager en France, on peut prendre le train. Le TGV est un train très rapide. Il va de Paris à Lyon en deux heures. On peut acheter les billets sur Internet ou à la gare. C'est facile et pratique.

On peut aussi voyager en voiture. Les autoroutes sont grandes et bien organisées. Mais attention, il faut payer le péage ! Beaucoup de Français partent en voiture pour les vacances d'été. En juillet et en août, il y a souvent des embouteillages sur les routes.

L'avion est utile pour les longues distances. Par exemple, de Paris à Nice, le vol dure seulement une heure et demie. Mais l'aéroport est souvent loin du centre-ville.

Pour les courtes distances, le bus est une option économique. Il y a des compagnies de bus qui relient les grandes villes pour un prix très bas.

Chaque moyen de transport a ses avantages. Le plus important, c'est de profiter du voyage !`,
    questions: [
      { q: 'Qu\'est-ce que le TGV ?', a: 'Le TGV est un train très rapide en France.' },
      { q: 'Combien de temps met le TGV de Paris à Lyon ?', a: 'Il met deux heures.' },
      { q: 'Que faut-il payer sur l\'autoroute ?', a: 'Il faut payer le péage.' },
      { q: 'Quand y a-t-il des embouteillages ?', a: 'En juillet et en août, pendant les vacances d\'été.' },
      { q: 'Quel transport est le plus économique ?', a: 'Le bus est l\'option la plus économique.' },
      { q: 'Vrai ou faux : Le vol Paris-Nice dure trois heures.', a: 'Faux — le vol dure seulement une heure et demie.' },
    ],
    expression: [
      'Quel moyen de transport utilisez-vous le plus souvent ?',
      'Racontez un voyage que vous avez fait.',
      'Quel est le meilleur moyen de transport selon vous ? Pourquoi ?',
    ],
    speaking: 'Décrivez comment vous voyagez habituellement : quel transport vous utilisez, pourquoi, et racontez un trajet récent.',
  },
  {
    id: 'au-restaurant',
    title: 'Au restaurant',
    level: 'A1',
    theme: 'Food & dining',
    warmup: [
      'Allez-vous souvent au restaurant ?',
      'Quel est votre plat préféré ?',
      'Préférez-vous manger à la maison ou au restaurant ?',
    ],
    text: `Vendredi soir, je suis allé au restaurant avec ma copine. Le restaurant s'appelle « Chez Marcel ». C'est un petit restaurant français dans notre quartier.

Nous sommes arrivés à 20 heures. Le serveur nous a donné une table près de la fenêtre. Il a apporté la carte et nous avons choisi nos plats.

En entrée, j'ai pris une soupe à l'oignon. Ma copine a commandé une salade verte avec du fromage de chèvre. La soupe était chaude et délicieuse.

Comme plat principal, j'ai choisi un steak-frites. Le steak était bien cuit et les frites étaient croustillantes. Ma copine a pris du poulet avec des légumes grillés. Elle a beaucoup aimé.

Pour le dessert, nous avons partagé une tarte aux pommes avec de la crème fraîche. C'était le meilleur dessert du menu !

Nous avons aussi bu une bouteille d'eau gazeuse et un café à la fin du repas. L'addition était de 45 euros pour deux personnes. Ce n'était pas cher pour un si bon dîner.

Nous avons passé une très bonne soirée. Le serveur était sympathique et la nourriture était excellente. Nous voulons y retourner bientôt.`,
    questions: [
      { q: 'Comment s\'appelle le restaurant ?', a: 'Le restaurant s\'appelle « Chez Marcel ».' },
      { q: 'Qu\'a commandé le narrateur en entrée ?', a: 'Il a pris une soupe à l\'oignon.' },
      { q: 'Quel était le plat principal de sa copine ?', a: 'Elle a pris du poulet avec des légumes grillés.' },
      { q: 'Qu\'ont-ils mangé en dessert ?', a: 'Ils ont partagé une tarte aux pommes avec de la crème fraîche.' },
      { q: 'Combien a coûté l\'addition ?', a: 'L\'addition était de 45 euros pour deux personnes.' },
      { q: 'Vrai ou faux : Le serveur était désagréable.', a: 'Faux — le serveur était sympathique.' },
    ],
    expression: [
      'Décrivez votre dernier repas au restaurant.',
      'Quel est votre plat préféré au restaurant ?',
      'Préférez-vous les restaurants français, italiens ou asiatiques ? Pourquoi ?',
    ],
    speaking: 'Racontez un dîner au restaurant : ce que vous avez mangé, avec qui, et si vous avez aimé.',
  },
  {
    id: 'faire-du-shopping',
    title: 'Faire du shopping',
    level: 'A1',
    theme: 'Shopping & clothing',
    warmup: [
      'Aimez-vous faire du shopping ?',
      'Où achetez-vous vos vêtements ?',
      'Préférez-vous les magasins ou les achats en ligne ?',
    ],
    text: `Aujourd'hui, c'est samedi. Claire veut acheter de nouveaux vêtements. Elle va au centre commercial avec son amie Pauline.

D'abord, elles entrent dans un magasin de vêtements. Claire regarde les robes. Elle essaie une robe bleue et une robe rouge. La robe bleue est trop grande, mais la robe rouge est parfaite. Elle coûte 35 euros. Claire l'achète.

Ensuite, Pauline cherche un pull. Elle trouve un joli pull noir en laine. Il est chaud et confortable. Il coûte 29 euros. Pauline est contente de son achat.

Après les vêtements, elles vont dans un magasin de chaussures. Claire achète des baskets blanches pour le sport. Pauline essaie des bottes marron, mais elles sont trop petites. Elle ne les achète pas.

À midi, elles font une pause dans un café du centre commercial. Elles boivent un chocolat chaud et mangent un croissant. Elles parlent de leurs achats et elles rient beaucoup.

L'après-midi, Claire achète aussi un livre et un cadeau pour sa mère — un foulard en soie. Elles rentrent chez elles vers 16 heures, fatiguées mais contentes de leur journée de shopping.`,
    questions: [
      { q: 'Pourquoi Claire va-t-elle au centre commercial ?', a: 'Elle veut acheter de nouveaux vêtements.' },
      { q: 'Quelle robe achète Claire ?', a: 'Elle achète la robe rouge qui coûte 35 euros.' },
      { q: 'Pourquoi la robe bleue ne convient pas ?', a: 'La robe bleue est trop grande.' },
      { q: 'Que trouve Pauline ?', a: 'Elle trouve un joli pull noir en laine à 29 euros.' },
      { q: 'Pourquoi Pauline n\'achète-t-elle pas les bottes ?', a: 'Les bottes sont trop petites.' },
      { q: 'Que fait Claire pour sa mère ?', a: 'Elle achète un foulard en soie comme cadeau.' },
      { q: 'Vrai ou faux : Elles mangent dans un restaurant.', a: 'Faux — elles mangent dans un café du centre commercial.' },
    ],
    expression: [
      'Décrivez votre dernière sortie shopping.',
      'Quel type de vêtements aimez-vous acheter ?',
      'Préférez-vous acheter en magasin ou sur Internet ? Pourquoi ?',
    ],
    speaking: 'Décrivez une journée de shopping : où vous êtes allé, ce que vous avez acheté et combien vous avez dépensé.',
  },
  {
    id: 'habitudes-numeriques',
    title: 'Les habitudes numériques des jeunes',
    level: 'B1',
    theme: 'Technology & lifestyle',
    warmup: [
      'Combien de temps passes-tu sur ton téléphone chaque jour ?',
      'Penses-tu que c\'est trop ?',
    ],
    text: `Aujourd'hui, les jeunes passent beaucoup de temps sur leurs téléphones et leurs ordinateurs. Les réseaux sociaux, les vidéos en ligne et les jeux occupent une grande partie de leur journée.

Pour beaucoup, ces outils sont essentiels pour communiquer avec leurs amis et se divertir. Ils permettent aussi de s'informer rapidement sur ce qui se passe dans le monde.

Cependant, cette utilisation peut parfois devenir excessive. Certains jeunes ont du mal à se concentrer sur leurs études et dorment moins à cause des écrans.

Les spécialistes recommandent de limiter le temps passé en ligne et de pratiquer d'autres activités, comme le sport ou la lecture.

Trouver un équilibre entre vie numérique et vie réelle est donc devenu un véritable défi pour les jeunes aujourd'hui.`,
    questions: [
      { q: 'Pourquoi les jeunes utilisent-ils beaucoup leurs téléphones ?', a: 'Pour communiquer avec leurs amis, se divertir et s\'informer sur ce qui se passe dans le monde.' },
      { q: 'Quels sont les avantages mentionnés ?', a: 'Communiquer avec les amis, se divertir et s\'informer rapidement.' },
      { q: 'Quels sont les problèmes liés à cette utilisation ?', a: 'Certains jeunes ont du mal à se concentrer sur leurs études et dorment moins à cause des écrans.' },
    ],
    expression: [
      'Combien de temps passes-tu sur ton téléphone ?',
      'Comment peux-tu mieux gérer ton temps ?',
    ],
    speaking: 'Explique ta relation avec les écrans pendant 2 à 3 minutes.',
  },
  {
    id: 'travailler-pendant-etudes',
    title: 'Travailler pendant les études',
    level: 'B1',
    theme: 'Work & education',
    warmup: [
      'Penses-tu qu\'il est utile de travailler pendant ses études ?',
    ],
    text: `De nombreux étudiants choisissent de travailler en même temps que leurs études. Ils occupent souvent des emplois à temps partiel dans des cafés, des magasins ou des entreprises.

Cette expérience leur permet de gagner de l'argent, mais aussi de développer des compétences importantes. Ils apprennent à gérer leur temps, à communiquer avec des clients et à travailler en équipe.

Cependant, il peut être difficile de concilier travail et études. Certains étudiants se sentent fatigués et ont moins de temps pour réviser leurs cours.

Pour réussir, il est essentiel d'organiser son emploi du temps et de rester motivé.`,
    questions: [
      { q: 'Pourquoi les étudiants travaillent-ils ?', a: 'Pour gagner de l\'argent et développer des compétences importantes.' },
      { q: 'Quels sont les avantages ?', a: 'Gagner de l\'argent, apprendre à gérer son temps, communiquer avec des clients et travailler en équipe.' },
      { q: 'Quelles sont les difficultés ?', a: 'Il peut être difficile de concilier travail et études ; certains étudiants sont fatigués et ont moins de temps pour réviser.' },
    ],
    expression: [
      'Aimerais-tu travailler pendant tes études ? Pourquoi ?',
    ],
    speaking: 'Donne ton opinion sur le travail étudiant pendant 2 à 3 minutes.',
  },
  {
    id: 'vivre-grande-ville',
    title: 'Vivre dans une grande ville',
    level: 'B1',
    theme: 'Urban life & choices',
    warmup: [
      'Préfères-tu vivre en ville ou à la campagne ?',
    ],
    text: `Vivre dans une grande ville présente de nombreux avantages. On y trouve plus d'opportunités de travail, d'études et de loisirs.

Les transports publics permettent de se déplacer facilement, et il existe une grande diversité de restaurants, de magasins et d'activités culturelles.

Cependant, la vie en ville peut aussi être stressante. Le bruit, la pollution et le coût de la vie sont souvent plus élevés qu'à la campagne.

Certaines personnes préfèrent donc un mode de vie plus calme, loin de l'agitation urbaine.

Le choix dépend finalement du style de vie et des priorités de chacun.`,
    questions: [
      { q: 'Quels sont les avantages de la vie en ville ?', a: 'Plus d\'opportunités de travail, d\'études et de loisirs, des transports publics, une grande diversité de restaurants, magasins et activités culturelles.' },
      { q: 'Quels sont les inconvénients ?', a: 'Le bruit, la pollution et le coût de la vie sont souvent plus élevés qu\'à la campagne.' },
    ],
    expression: [
      'Où préfères-tu vivre ? Pourquoi ?',
    ],
    speaking: 'Compare la vie en ville et à la campagne pendant 2 à 3 minutes.',
  },
];

